// ============================================
// КОМПОНЕНТЫ ВЫНЕСЕНЫ В ОТДЕЛЬНЫЕ ФАЙЛЫ
// См. src/js/components/
// ============================================

// ============================================
// УТИЛИТЫ ВЫНЕСЕНЫ В ОТДЕЛЬНЫЕ ФАЙЛЫ
// См. src/js/utils/
// ============================================

// ---------- Campus Selector ----------
// Переменные для элементов кампуса (инициализируются при DOM ready)
let campusSelectorBtn, campusModal, selectedCampus, campusOptions, campusTabButtons;

// Антибот формы брошюры (block7); инициализация в initAllForms — должна быть в области видимости модуля
let antibot7;

// ============================================
// ОБРАБОТКА ЯКОРНЫХ ССЫЛОК С ОТСТУПОМ
// ============================================
function initLandingAnchorLinks() {
  if (document.body.classList.contains('middle-high-page')) return;
  document.addEventListener('click', function (e) {
    const anchor = e.target.closest('a[href^="#"]');
    if (!anchor) return;

    const href = anchor.getAttribute('href');
    // Пропускаем пустые якоря и якоря, которые обрабатываются другими обработчиками
    // Также пропускаем ссылки внутри dropdown-menu на мобильных устройствах, чтобы избежать двойного срабатывания
    if (!href || href === '#' ||
      anchor.closest('.card_school_link') ||
      (window.innerWidth <= 1195 && anchor.closest('.dropdown-menu'))) {
      return;
    }

    // Проверяем, не был ли уже обработан этот клик
    if (anchor.hasAttribute('data-processed')) {
      return;
    }
    anchor.setAttribute('data-processed', 'true');

    // Удаляем атрибут через небольшую задержку
    setTimeout(() => {
      anchor.removeAttribute('data-processed');
    }, 100);

    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      e.preventDefault();
      e.stopPropagation();

      // Получаем высоту навигационной панели
      const navBar = document.querySelector('.nav-bar');
      const topBar = document.querySelector('.top_bar');
      let offset = 20; // Базовый отступ

      if (topBar) {
        const topBarHeight = topBar.offsetHeight;
        offset += topBarHeight;
      }

      if (navBar) {
        const navBarHeight = navBar.offsetHeight;
        offset += navBarHeight;
      }

      // Вычисляем позицию с учетом отступа
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;

      // Плавная прокрутка
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }, true); // Используем capture phase для раннего перехвата
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initLandingAnchorLinks);
} else {
  initLandingAnchorLinks();
}

// Код компонентов вынесен в src/js/components/
// regionSelector.js, accordion.js, passwordProtection.js

// Инициализация intl-tel-input для первой формы будет в секции валидации

// Код аккордеона вынесен в components/accordion.js

// Код слайдера кампуса вынесен в components/campusSlider.js

// Кнопка таба «Территория»: старая разметка data-campus="tgn", internal — data-campus-tab="territory"
function getTerritoryCampusTabButton() {
  return document.querySelector('.campus_buttons_group .campus_btn[data-campus="tgn"]')
    || document.querySelector('.campus_buttons_group .campus_btn[data-campus-tab="territory"]');
}

// Инициализация элементов кампуса
function initCampusDom() {
  if (document.body.classList.contains("middle-high-page") && !document.querySelector("[data-secondary-campus-gallery]")) {
    return;
  }
  // Начальная школа: галерея с data-secondary-campus-gallery — табы data-campus-tab; без неё обработчики в primary/js
  if (document.body.classList.contains('primary-school-page') && !document.querySelector('[data-secondary-campus-gallery]')) return;
  campusSelectorBtn = document.getElementById("campusSelectorBtn");
  campusModal = document.getElementById("campusModal");
  selectedCampus = document.getElementById("selectedCampus");
  campusOptions = document.querySelectorAll(".campus_option");
  const galleryRoot = document.querySelector("[data-secondary-campus-gallery]");
  campusTabButtons = galleryRoot
    ? galleryRoot.querySelectorAll(".campus_buttons_group .campus_btn")
    : document.querySelectorAll(".campus_buttons_group .campus_btn");

  // Инициализация обработчиков событий для кампуса (на /campuses/:slug/ селектор скрыт)
  if (campusSelectorBtn && campusModal && !getLockedCampusSlug()) {
    campusSelectorBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      const isOpening = !campusModal.classList.contains("open");
      campusModal.classList.toggle("open");
      campusSelectorBtn.classList.toggle("active");
      campusSelectorBtn.classList.toggle("menu-open");

      // Убираем active со всех кнопок табов (Территория, Интерьер и т.д.)
      campusTabButtons.forEach((btn) => {
        btn.classList.remove("active");
      });

      // Если модальное окно открывается, делаем кнопку выбора города активной
      if (isOpening) {
        campusSelectorBtn.classList.add("active");
      } else {
        // Если закрывается, убираем active и активируем кнопку "Территория"
        campusSelectorBtn.classList.remove("active");
        const territoryBtn = getTerritoryCampusTabButton();
        if (territoryBtn) {
          territoryBtn.classList.add("active");
        }
      }
    });

    campusOptions.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        const campusId = option.dataset.campus;
        selectCampus(campusId);
      });
    });

    document.addEventListener("click", (e) => {
      if (!campusSelectorBtn.contains(e.target) && !campusModal.contains(e.target)) {
        closeCampusModal();
      }
    });
  }

  // Обработчики для остальных кнопок (Территория, Интерьер и т.д.)
  if (campusTabButtons && campusTabButtons.length > 0) {
    campusTabButtons.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation();

        // Убираем active со всех кнопок табов
        campusTabButtons.forEach((b) => {
          b.classList.remove("active");
        });

        // Добавляем active к нажатой кнопке
        btn.classList.add("active");

        // Категория: data-campus (tgn, int, …) или data-campus-tab (territory, interior, …)
        const tabKey = btn.dataset.campusTab;
        let categoryId = btn.dataset.campus;
        if (!categoryId && tabKey) {
          const tabToCategory = { territory: "tgn", interior: "int", lessons: "lessons", events: "events" };
          categoryId = tabToCategory[tabKey] || "tgn";
        }
        const currentCampusId = getCurrentCampus();

        // Загружаем фотографии для выбранной категории и кампуса
        const locked = getLockedCampusSlug();
        if (
          locked &&
          tabKey &&
          typeof window.switchLockedCampusGalleryTab === "function" &&
          window.switchLockedCampusGalleryTab(tabKey)
        ) {
          return;
        }
        const reloadOpts = locked
          ? { forceReload: true, tabKey: tabKey || "territory" }
          : {};
        if (typeof window.loadCampusImages === 'function') {
          window.loadCampusImages(currentCampusId, categoryId, reloadOpts);
        } else if (typeof loadCampusImages === 'function') {
          loadCampusImages(currentCampusId, categoryId, reloadOpts);
        }
      });
    });
  }

  // Block20: на internal_2025 с data-secondary-contacts контакты и карта — public/secondary/js/script.js (initSecondaryContacts).
  // Иначе обработчики главной дублируются и селектор сразу открывается и закрывается (toggle + toggle с shouldOpen).
  if (!document.querySelector("[data-secondary-contacts]")) {

  // Обработчики для Block20 - кнопки кампусов
  const block20CampusButtons = document.querySelectorAll('.block20_campus_btn');
  block20CampusButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const campusId = btn.getAttribute('data-campus');
      if (campusId) {
        selectCampus(campusId);
      }
    });
  });

  // Обработчики для Block20 - селектор кампуса
  const block20CampusSelectorBtn = document.getElementById('block20CampusSelectorBtn');
  const block20CampusModal = document.getElementById('block20CampusModal');
  const block20CampusOptions = document.querySelectorAll('.block20_campus_option');

  if (block20CampusSelectorBtn && block20CampusModal) {
    block20CampusSelectorBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      block20CampusModal.classList.toggle('open');
      block20CampusSelectorBtn.classList.toggle('menu-open');
    });

    // Обработчики для опций будут добавлены позже в функции selectBlock20Campus

    document.addEventListener('click', (e) => {
      if (!block20CampusSelectorBtn.contains(e.target) && !block20CampusModal.contains(e.target)) {
        block20CampusModal.classList.remove('open');
        block20CampusSelectorBtn.classList.remove('menu-open');
      }
    });
  }

  // ============================================
  // BLOCK20: YANDEX MAPS ИНИЦИАЛИЗАЦИЯ
  // ============================================

  // Переменная для хранения объекта карты
  let localYandexMap = null;
  // Переменная для хранения всех маркеров кампусов (для восстановления общей карты)
  let allCampusPlacemarks = [];

  // Данные о кампусах с адресами и координатами
  const campusesData = {
    skolkovo: {
      title: 'Сколково',
      address: '143085, Россия, МО, Одинцовский район, Заречье, Березовая ул., 2',
      coordinates: '55.692191, 37.397611',
      contacts: {
        admissionsManager: {
          phone: '+7 (495) 492-11-85',
          phoneHref: 'tel:+74954921185'
        },
        contractManager: {
          phone: '+7 903 575 26 96',
          phoneHref: 'tel:+79035752696',
          email: 'natalia.toporova@cisedu.com'
        },
        secretary: {
          email: 'skolkovo@cisedu.com',
          phones: [
            { label: 'Секретарь начальной школы', phone: '+7 (495) 255-22-49', phoneHref: 'tel:+74952552249' },
            { label: 'Секретарь средней школы', phone: '+7 (495) 255-22-02', phoneHref: 'tel:+74952552202' }
          ]
        }
      }
    },
    moscow: {
      title: 'Москва',
      address: '125565, Россия, Москва, Фестивальная ул., 7A',
      coordinates: '55.855760, 37.473734',
      contacts: {
        admissionsManager: {
          phone: '+7 (495) 120-15-17',
          phoneHref: 'tel:+74951201517'
        },
        contractManager: {
          phone: '+7 968 778 80 54',
          phoneHref: 'tel:+79687788054',
          email: 'elena.rysyeva@cisedu.com'
        },
        secretary: {
          email: 'moscow@cisedu.com',
          phones: [
            { label: 'Секретарь кампуса', phone: '+7 (495) 152-77-30', phoneHref: 'tel:+74951527730' }
          ]
        }
      }
    },
    gorki: {
      title: 'Горки',
      address: '143081, Россия, Московская область, Одинцовский район, деревня Солослово, коттеджный поселок «Березки»',
      coordinates: '55.699571, 37.154794',
      contacts: {
        admissionsManager: {
          phone: '+7 (495) 159-04-88',
          phoneHref: 'tel:+74951590488'
        },
        contractManager: {
          phone: '+7 963 996 86 26',
          phoneHref: 'tel:+79639968626',
          email: 'irina.trayan@cisedu.com'
        },
        secretary: {
          email: 'gorki@cisedu.com',
          phones: [
            { label: 'Секретарь начальной школы', phone: '+7 (495) 152-83-83', phoneHref: 'tel:+74951528383' },
            { label: 'Секретарь средней школы', phone: '+7 (495) 162-51-15', phoneHref: 'tel:+74951625115' }
          ]
        }
      }
    },
    spb: {
      title: 'Санкт-Петербург',
      address: '197183, РФ, Санкт-Петербург, ул.Приморский проспект, 62 к1, стр. 1',
      coordinates: '59.982770, 30.225740',
      contacts: {
        admissionsManager: {
          phone: '+7 (812) 220-84-46',
          phoneHref: 'tel:+78122208446'
        },
        contractManager: {
          phone: '+7 966 751 3032',
          phoneHref: 'tel:+79667513032',
          email: 'tatyana.gubar@cisedu.com'
        },
        secretary: {
          email: 'spb@cisedu.com',
          phones: [
            { label: 'Секретарь кампуса', phone: '+7 (812) 604-33-22', phoneHref: 'tel:+78126043322' }
          ]
        }
      }
    },
    tashkent: {
      title: 'Ташкент',
      address: '100057, Узбекистан, Ташкент, Алмазарский район, улица Кичик Халка Йули, 1А',
      coordinates: '41.349266, 69.256354',
      contacts: {
        admissionsManager: {
          phone: '+998 (71) 209 66 69',
          phoneHref: 'tel:+998712096669'
        },
        contractManager: {
          phone: '+998 (71) 209 66 69, доб. 105',
          phoneHref: 'tel:+998712096669',
          email: 'tashkent@cisedu.com'
        },
        secretary: {
          email: 'tashkent@cisedu.com',
          phones: [
            { label: 'Секретарь кампуса', phone: '+998 (71) 209 66 69', phoneHref: 'tel:+998712096669' }
          ]
        }
      }
    }
  };

  // Функция обновления информации о кампусе в block20_info_section
  function updateCampusInfo(campusId) {
    const campusData = campusesData[campusId];
    if (!campusData) return;

    // Обновляем название кампуса
    const campusTitleName = document.querySelector('.block20_campus_title_name');
    if (campusTitleName) {
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
      if (t && t[`campus_name_${campusId}`]) {
        campusTitleName.textContent = t[`campus_name_${campusId}`];
      } else {
        campusTitleName.textContent = campusData.title;
      }
    }

    // Обновляем адрес
    const addressValue = document.querySelector('.block20_address_value');
    if (addressValue) {
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
      const addressKey = `block20_address_${campusId}`;
      if (t && t[addressKey]) {
        addressValue.textContent = t[addressKey];
      } else {
        addressValue.textContent = campusData.address;
      }
    }

    // Обновляем координаты
    const coordinatesValue = document.querySelector('.block20_coordinates_value');
    if (coordinatesValue) {
      coordinatesValue.textContent = campusData.coordinates;
    }

    // Обновляем контакты в зависимости от выбранного кампуса
    const contactGroups = document.querySelectorAll('.block20_contact_group');
    const contacts = campusData.contacts;

    if (!contacts) return;

    // Первая группа: "Для поступающих" - Менеджер по приему
    if (contactGroups.length > 0 && contacts.admissionsManager) {
      const firstGroup = contactGroups[0];
      const firstContactItem = firstGroup.querySelector('.block20_contact_item');
      if (firstContactItem) {
        const firstContactValues = firstContactItem.querySelectorAll('.block20_contact_value');
        // Email менеджера по зачислению удален
        // Телефон
        const firstPhone = Array.from(firstContactValues).find(c => c.getAttribute('href') && c.getAttribute('href').includes('tel:'));
        if (firstPhone) {
          firstPhone.setAttribute('href', contacts.admissionsManager.phoneHref);
          firstPhone.textContent = contacts.admissionsManager.phone;
        }
      }
    }

    // Вторая группа: "Для учащихся кампуса" - Секретарь и Менеджер по договорам
    if (contactGroups.length > 1) {
      const secondGroup = contactGroups[1];
      const secondGroupContactItems = secondGroup.querySelectorAll('.block20_contact_item');

      // Секретарь кампуса
      if (secondGroupContactItems.length > 0 && contacts.secretary) {
        const secretaryItem = secondGroupContactItems[0];
        const secretaryEmail = document.getElementById('block20_secretary_email');
        const secretaryPhones = document.getElementById('block20_secretary_phones');

        if (secretaryEmail) {
          secretaryEmail.setAttribute('href', `mailto:${contacts.secretary.email}`);
          secretaryEmail.textContent = contacts.secretary.email;
        }

        // Обновляем телефоны секретарей
        if (secretaryPhones && contacts.secretary.phones) {
          secretaryPhones.innerHTML = '';
          contacts.secretary.phones.forEach((phoneData) => {
            // Просто добавляем ссылку на телефон без подписей
            const phoneLink = document.createElement('a');
            phoneLink.href = phoneData.phoneHref;
            phoneLink.className = 'block20_contact_value';
            phoneLink.textContent = phoneData.phone;
            secretaryPhones.appendChild(phoneLink);
          });
        }
      }

      // Менеджер по договорам
      if (secondGroupContactItems.length > 1 && contacts.contractManager) {
        const contractItem = secondGroupContactItems[1];
        const contractEmail = document.getElementById('block20_contract_email');
        const contractPhone = document.getElementById('block20_contract_phone');

        if (contractEmail) {
          contractEmail.setAttribute('href', `mailto:${contacts.contractManager.email}`);
          contractEmail.textContent = contacts.contractManager.email;
        }

        if (contractPhone) {
          contractPhone.setAttribute('href', contacts.contractManager.phoneHref);
          contractPhone.textContent = contacts.contractManager.phone;
        }
      }
    }

    // Устанавливаем правильные метки контактов и график работы (на случай, если сервер отдал старые значения)
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    if (t) {
      const contactLabels = document.querySelectorAll('.block20_campuses .block20_contact_label');
      const labelKeys = ['block20_contact_label_admissions_manager', 'block20_contact_label_campus_secretary', 'block20_contact_label_contract_manager'];
      contactLabels.forEach((el, i) => {
        if (labelKeys[i] && t[labelKeys[i]]) el.textContent = t[labelKeys[i]];
      });
      const hoursTimes = document.querySelectorAll('.block20_campuses .block20_hours_time');
      hoursTimes.forEach(el => {
        const text = el.textContent.trim();
        if (text === '8:30-17:00' || text === '8:30 - 17:00') el.textContent = '8:00-17:00';
      });
    }
  }
  window.updateCampusInfo = updateCampusInfo;

  // Обработчики кликов на кнопки кампусов для обновления карт
  block20CampusButtons.forEach(button => {
    button.addEventListener('click', function () {
      const campusKey = this.getAttribute('data-campus');
      if (typeof window.cancelBlock20AutoZoom === 'function') window.cancelBlock20AutoZoom();

      // Убираем active со всех кнопок
      block20CampusButtons.forEach(btn => btn.classList.remove('active'));

      // Добавляем active к текущей кнопке
      this.classList.add('active');

      // Обновляем информацию (внутри updateCampusInfo уже вызывается translatePage)
      updateCampusInfo(campusKey);

      // Приближаем локальную карту к выбранному кампусу
      // НЕ удаляем маркеры, просто приближаем карту к выбранному кампусу
      if (localYandexMap && campusesData[campusKey]) {
        const address = campusesData[campusKey].address;

        // Используем геокодирование для получения координат по адресу
        if (typeof ymaps !== 'undefined' && ymaps.geocode) {
          ymaps.geocode(address).then(function (res) {
            if (res && res.geoObjects) {
              const firstGeoObject = res.geoObjects.get(0);
              if (firstGeoObject && localYandexMap) {
                const coords = firstGeoObject.geometry.getCoordinates();

                // НЕ очищаем маркеры - оставляем все маркеры на карте
                // Просто приближаем карту к выбранному кампусу
                // Используем правильный синтаксис Yandex Maps: setCenter с зумом как второй параметр
                localYandexMap.setCenter(coords, 15, {
                  duration: 300,
                  checkZoomRange: true
                });
              }
            }
          }).catch(function (error) {
            // Fallback на координаты
            const fallbackCoords = {
              skolkovo: [55.692191, 37.397611],
              moscow: [55.855760, 37.473734],
              gorki: [55.699571, 37.154794],
              spb: [59.982770, 30.225740],
              tashkent: [41.349266, 69.256354]
            };
            if (fallbackCoords[campusKey] && localYandexMap) {
              // НЕ очищаем маркеры - оставляем все маркеры на карте
              // Просто приближаем карту к выбранному кампусу
              // Используем правильный синтаксис Yandex Maps: setCenter с зумом как второй параметр
              localYandexMap.setCenter(fallbackCoords[campusKey], 15, {
                duration: 300,
                checkZoomRange: true
              });
            }
          });
        }
      }
    });
  });

  // Block20 City Selector для мобильных устройств (при 1023px и меньше)
  const block20SelectedCampus = document.getElementById("block20SelectedCampus");
  const block20CampusNames = {
    skolkovo: "Сколково",
    moscow: "Москва",
    gorki: "Горки",
    spb: "Санкт-Петербург",
    tashkent: "Ташкент"
  };

  function selectBlock20Campus(campusId, updateMap = true) {
    if (updateMap && typeof window.cancelBlock20AutoZoom === 'function') {
      window.cancelBlock20AutoZoom();
    }
    // Синхронизируем выбор города во всех блоках
    syncCampusSelection(campusId);

    // Получаем название кампуса с учетом текущего языка
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    let campusName = block20CampusNames[campusId] || campusId;

    if (t && t[`campus_name_${campusId}`]) {
      campusName = t[`campus_name_${campusId}`];
    }

    if (block20SelectedCampus) {
      block20SelectedCampus.textContent = campusName;
    }

    // Обновляем информацию о кампусе (с задержкой для гарантии обновления DOM и переводов)
    setTimeout(() => {
      if (typeof updateCampusInfo === 'function') {
        updateCampusInfo(campusId);
      } else if (typeof window.updateCampusInfo === 'function') {
        window.updateCampusInfo(campusId);
      }
    }, 100);

    // Закрываем модальное окно
    if (block20CampusModal) {
      block20CampusModal.classList.remove("open");
    }

    // Убираем класс menu-open
    if (block20CampusSelectorBtn) {
      block20CampusSelectorBtn.classList.remove("menu-open");
    }

    // Активируем соответствующую кнопку (для синхронизации на больших экранах)
    block20CampusButtons.forEach(btn => {
      btn.classList.remove('active');
      if (btn.getAttribute('data-campus') === campusId) {
        btn.classList.add('active');
      }
    });

    // Приближаем локальную карту к выбранному кампусу только если updateMap = true
    // НЕ удаляем маркеры, просто приближаем карту к выбранному кампусу
    if (updateMap && localYandexMap && campusesData[campusId]) {
      const address = campusesData[campusId].address;

      // Используем геокодирование для получения координат по адресу
      if (typeof ymaps !== 'undefined' && ymaps.geocode) {
        ymaps.geocode(address).then(function (res) {
          if (res && res.geoObjects) {
            const firstGeoObject = res.geoObjects.get(0);
            if (firstGeoObject && localYandexMap) {
              const coords = firstGeoObject.geometry.getCoordinates();

              // НЕ очищаем маркеры - оставляем все маркеры на карте
              // Просто приближаем карту к выбранному кампусу
              // Используем правильный синтаксис Yandex Maps: setCenter с зумом как второй параметр
              localYandexMap.setCenter(coords, 15, {
                duration: 300,
                checkZoomRange: true
              });
            }
          }
        }).catch(function (error) {
          // Fallback на координаты
          const fallbackCoords = {
            skolkovo: [55.692191, 37.397611],
            moscow: [55.855760, 37.473734],
            gorki: [55.699571, 37.154794],
            spb: [59.982770, 30.225740],
            tashkent: [41.349266, 69.256354]
          };
          if (fallbackCoords[campusId] && localYandexMap) {
            // НЕ очищаем маркеры - оставляем все маркеры на карте
            // Просто приближаем карту к выбранному кампусу
            // Используем правильный синтаксис Yandex Maps: setCenter с зумом как второй параметр
            localYandexMap.setCenter(fallbackCoords[campusId], 15, {
              duration: 300,
              checkZoomRange: true
            });
          }
        });
      }
    }
  }

  // Экспортируем функцию глобально для использования в других модулях
  window.selectBlock20Campus = selectBlock20Campus;

  // Обновляем обработчики для селектора, чтобы вызывать selectBlock20Campus
  // (обработчики уже добавлены выше, но они вызывают selectCampus)
  // Переопределяем их, чтобы вызывать selectBlock20Campus с обновлением карт
  if (block20CampusSelectorBtn && block20CampusModal && block20CampusOptions.length > 0) {
    block20CampusOptions.forEach((option) => {
      // Клонируем элемент, чтобы удалить все старые обработчики
      const newOption = option.cloneNode(true);
      option.parentNode.replaceChild(newOption, option);
      // Добавляем новый обработчик
      newOption.addEventListener("click", (e) => {
        e.stopPropagation();
        const campusId = newOption.getAttribute("data-campus");
        if (campusId) {
          selectBlock20Campus(campusId);
        }
      });
    });
  }

  // Синхронизация селектора с кнопками
  block20CampusButtons.forEach(button => {
    button.addEventListener('click', function () {
      const campusKey = this.getAttribute('data-campus');
      // Синхронизируем выбор города во всех блоках
      syncCampusSelection(campusKey);
      selectBlock20Campus(campusKey);
    });
  });

  // Инициализация информации о кампусе по умолчанию
  // Не вызываем здесь, так как кампус будет установлен при загрузке региона
  // updateCampusInfo будет вызван в selectBlock20Campus или applyRegion

  // Исправляем метки контактов и график при загрузке (на случай старых данных с сервера)
  function fixBlock20LabelsAndHours() {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    if (!t) return;
    const labels = document.querySelectorAll('.block20_campuses .block20_contact_label');
    ['block20_contact_label_admissions_manager', 'block20_contact_label_campus_secretary', 'block20_contact_label_contract_manager'].forEach((key, i) => {
      if (labels[i] && t[key]) labels[i].textContent = t[key];
    });
    document.querySelectorAll('.block20_campuses .block20_hours_time').forEach(el => {
      const text = el.textContent.trim();
      if (text === '8:30-17:00' || text === '8:30 - 17:00') el.textContent = '8:00-17:00';
    });
  }
  setTimeout(fixBlock20LabelsAndHours, 50);
  setTimeout(fixBlock20LabelsAndHours, 300);

  // Инициализация Яндекс.Карты (локальная карта с функционалом общей карты)
  var block20MapInitialized = false;
  var autoZoomTimer = null;
  var autoZoomDone = false;

  function cancelBlock20AutoZoom() {
    if (autoZoomTimer) { clearTimeout(autoZoomTimer); autoZoomTimer = null; }
    autoZoomDone = true;
  }
  window.cancelBlock20AutoZoom = cancelBlock20AutoZoom;

  function initBlock20LocalMap() {
    if (block20MapInitialized) return;
    var localMapContainer = document.getElementById('block20_local_yandex_map');
    if (!localMapContainer || typeof ymaps === 'undefined') return;
    block20MapInitialized = true;

    var campusesCoords = {
      skolkovo: [55.692191, 37.397611],
      moscow: [55.855760, 37.473734],
      gorki: [55.699571, 37.154794],
      spb: [59.982770, 30.225740],
      tashkent: [41.349266, 69.256354]
    };

    localYandexMap = new ymaps.Map('block20_local_yandex_map', {
      center: [50.0, 50.0],
      zoom: 3,
      controls: ['zoomControl', 'typeSelector', 'fullscreenControl'],
      behaviors: ['default', 'scrollZoom']
    });

    Object.keys(campusesData).forEach(function(campusKey) {
      var address = campusesData[campusKey].address;
      function addPlacemark(coords) {
        if (!coords || !localYandexMap) return;
        var pm = new ymaps.Placemark(coords, { hintContent: campusesData[campusKey]?.title || campusKey }, {
          iconLayout: 'default#image',
          iconImageHref: 'https://cisedu.com/favicon.ico',
          iconImageSize: [46, 46],
          iconImageOffset: [-23, -46]
        });
        localYandexMap.geoObjects.add(pm);
        allCampusPlacemarks.push(pm);
        campusesCoords[campusKey] = coords;
      }

      ymaps.geocode(address, { results: 1 }).then(function (res) {
        if (res && res.geoObjects && res.geoObjects.getLength() > 0) {
          var firstGeoObject = res.geoObjects.get(0);
          if (firstGeoObject) {
            addPlacemark(firstGeoObject.geometry.getCoordinates());
          } else {
            addPlacemark(campusesCoords[campusKey]);
          }
        } else {
          addPlacemark(campusesCoords[campusKey]);
        }
      }).catch(function() {
        addPlacemark(campusesCoords[campusKey]);
      });
    });

    // Auto-zoom: через 5 сек приближаем к кампусу по региону (Горки или Ташкент)
    if (!autoZoomDone) {
      autoZoomTimer = setTimeout(function() {
        if (autoZoomDone || !localYandexMap) return;
        autoZoomDone = true;

        var lockedCampus = getLockedCampusSlug();
        var curCountryEl = document.getElementById('curCountry');
        var regionText = curCountryEl ? curCountryEl.textContent.trim() : '';
        var isUzbekistan = regionText === 'Узбекистан' || regionText === 'Uzbekistan';
        var targetCampus = lockedCampus || (isUzbekistan ? 'tashkent' : 'gorki');
        var target = campusesCoords[targetCampus];
        if (target) {
          localYandexMap.setCenter(target, 15, { duration: 1000, checkZoomRange: true });
        }
        if (typeof window.selectBlock20Campus === 'function' && !lockedCampus) {
          window.selectBlock20Campus(targetCampus, false);
        }
      }, 5000);
    }
  }
  window.initBlock20LocalMap = initBlock20LocalMap;

  if (typeof ymaps !== 'undefined') {
    ymaps.ready(initBlock20LocalMap);
  } else {
    var checkYmaps = setInterval(function() {
      if (typeof ymaps !== 'undefined') {
        clearInterval(checkYmaps);
        ymaps.ready(initBlock20LocalMap);
      }
    }, 300);
    setTimeout(function() { clearInterval(checkYmaps); }, 30000);
  }
  }

  const lockedCampusSlug = getLockedCampusSlug();
  if (lockedCampusSlug && document.querySelector("[data-secondary-campus-gallery]")) {
    const territoryBtn = getTerritoryCampusTabButton();
    if (territoryBtn && campusTabButtons && campusTabButtons.length) {
      campusTabButtons.forEach((b) => b.classList.remove("active"));
      territoryBtn.classList.add("active");
    }
    const galleryRoot = document.querySelector("[data-secondary-campus-gallery]");
    const slidesEl = galleryRoot && galleryRoot.querySelector(".slides");
    const hasSlidesFromServer =
      slidesEl && slidesEl.querySelectorAll(".slide:not(.slide-clone)").length > 0;
    if (!hasSlidesFromServer && typeof window.loadCampusImages === "function") {
      window.loadCampusImages(lockedCampusSlug, "tgn", { forceReload: true, tabKey: "territory" });
    } else if (hasSlidesFromServer && typeof window.rebuildCampusGallerySlides === "function") {
      window.rebuildCampusGallerySlides();
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCampusDom);
} else {
  initCampusDom();
}

// Код hero слайдера вынесен в components/heroSlider.js

// Код Phone Flag Selector вынесен в components/phoneFlagSelector.js
// Функция initPhoneFlagSelectorStep2 экспортируется из phoneFlagSelector.js

// Данные кампусов (экспортируются для использования в campusSlider.js)
const campusNames = {
  skolkovo: "Сколково",
  moscow: "Москва",
  gorki: "Горки",
  spb: "Санкт-Петербург",
  tashkent: "Ташкент"
};

// Маппинг категорий табов на папки
const categoryFolders = {
  tgn: "territory",
  int: "interior",
  lessons: "classes",
  events: "events"
};

// Маппинг категорий для Ташкента (другие названия папок)
const categoryFoldersTashkent = {
  tgn: "territory",
  int: "interior",
  lessons: "Afterschool and Classes",
  events: "Events"
};

// Список фотографий для каждого кампуса и категории (галерея)
const campusGalleryImages = {
  spb: {
    territory: [
      "2021-06-04 10-17-01.webp",
      "2022-05-20-cis-1.webp",
      "2022-05-20-cis-4.webp",
      "2022-05-20-cis-76.webp",
      "2022-05-20-cis-81.webp",
      "IMG_6193.webp"
    ],
    interior: [
      "001_21_02_2019.webp",
      "019_31_01_2019.webp",
      "2022-05-20-cis-104.webp",
      "2022-05-20-cis-122.webp",
      "2022-05-20-cis-133.webp",
      "2022-05-20-cis-156.webp",
      "2022-05-20-cis-159.webp",
      "2022-05-20-cis-46.webp",
      "2022-05-20-cis-64.webp",
      "2022-05-20-cis-97.webp",
      "240_21_02_2019.webp",
      "360_21_02_2019.webp",
      "493_22_02_2019.webp",
      "SPN 20.04.2019-241.webp"
    ],
    classes: [
      "2022-05-20-cis-116.webp",
      "2022-05-20-cis-119.webp",
      "2022-05-20-cis-95.webp",
      "2022-05-20-cis-96.webp",
      "IMG_2723.webp",
      "IMG_2816.webp",
      "IMG_2915.webp"
    ],
    events: [
      "11.12.19_0026.webp",
      "11.12.19_0117.webp",
      "15.webp",
      "2022-05-20-cis-16.webp",
      "CJ0T7899.webp",
      "CJ0T8151.webp",
      "CJ0T8401.webp",
      "CJ0T8443.webp",
      "IMG_2790.webp"
    ]
  },
  moscow: {
    territory: [
      "2021-02-11-00360.webp",
      "2021-02-11-00366.webp",
      "2021-06-09-00499.webp",
      "2021-06-09-00566.webp",
      "SAV02129.webp",
      "SPN-100.webp",
      "SPN-106.webp",
      "SPN-285.webp"
    ],
    interior: [
      "2021-02-11-00007.webp",
      "2021-02-11-00059.webp",
      "2021-02-11-00061.webp",
      "2021-09-30-00027.webp",
      "2021-09-30-00054.webp",
      "2021-09-30-00088.webp",
      "CIS International School 047 .webp"
    ],
    classes: [
      "2021-02-11-00086.webp",
      "2021-02-11-00918.webp",
      "2021-06-09-00886.webp",
      "2021-06-09-01143.webp",
      "2021-06-09-01174.webp",
      "CIS International School 053 .webp",
      "SAV02160.webp",
      "SAV02220.webp",
      "SAV02287.webp",
      "SPN-339.webp"
    ],
    events: [
      "2021-06-09-00413.webp",
      "2021-12-14-00283.webp",
      "2021-12-14-04424.webp",
      "2022-03-03-cis-sk-00725.webp",
      "SAV01286.webp",
      "SAV01402.webp",
      "SAV01933.webp"
    ]
  },
  gorki: {
    territory: [
      "2019-10-01-04442.webp",
      "2019-10-01-04445.webp",
      "2019-10-01-04480.webp",
      "2019-10-01-04505.webp",
      "2019-10-01-04594.webp",
      "2019-10-01-04623.webp",
      "2019-10-01-04644.webp",
      "2019-10-01-04932.webp"
    ],
    interior: [
      "2019-10-01-03910.webp",
      "2019-10-01-03928.webp",
      "2019-10-01-04158.webp",
      "2019-10-01-04167.webp",
      "2019-10-01-04313.webp",
      "2019-10-01-04719.webp",
      "2019-10-01-04927.webp",
      "2019-10-01-04930.webp",
      "2019-10-01-04937.webp",
      "2019-10-01-04971.webp",
      "2019-10-01-04973.webp"
    ],
    classes: [
      "0Z1A6080.webp",
      "2019-10-01-04704.webp",
      "2019-10-01-04757.webp",
      "20200811_113739.webp",
      "IMG20200821111428.webp",
      "IMG_1033.webp",
      "IMG_9208.webp",
      "IMG_9225.webp",
      "IMG_9270.webp",
      "IMG_9315.webp"
    ],
    events: [
      "2019-09-02-05313.webp",
      "2019-12-12-00087.webp",
      "2019-12-12-00190.webp",
      "2021-06-04-CIS-gorki-00860.webp",
      "20220617-130717.webp",
      "20220618-021204.webp",
      "RYB_2350.webp",
      "RYB_3403.webp"
    ]
  },
  skolkovo: {
    territory: [
      "002.webp",
      "003.webp"
    ],
    interior: [
      "008.webp",
      "011.webp",
      "013.webp",
      "015.webp",
      "017.webp",
      "020.webp",
      "022.webp",
      "025.webp",
      "032.webp",
      "033.webp",
      "034.webp",
      "035.webp",
      "037.webp",
      "039.webp"
    ],
    classes: [
      "2021-03-05-00215.webp",
      "2021-12-10-00070.webp",
      "2022-04-15-sic-sk-122.webp",
      "2022-04-15-sic-sk-199.webp",
      "2022-04-15-sic-sk-29.webp",
      "2022-04-15-sic-sk-82.webp",
      "230901122849.webp"
    ],
    events: [
      "2022-09-23-CIS-sk-29.webp",
      "20230621-114804.webp",
      "20230621-132148.webp",
      "230901105905.webp",
      "70.webp",
      "DSC_5839.webp"
    ]
  },
  tashkent: {
    territory: [
      "IMG_6289.webp",
      "IMG_6296.webp",
      "IMG_6300.webp",
      "IMG_6649.webp",
      "IMG_6668.webp",
      "IMG_6999.webp",
      "IMG_7011.webp",
      "IMG_7026.webp",
      "IMG_7045.webp",
      "IMG_7055.webp",
      "PRO09835.webp"
    ],
    interior: [
      "IMG_6344.webp",
      "IMG_6359.webp",
      "IMG_6390.webp",
      "IMG_6398.webp",
      "IMG_6423.webp",
      "IMG_6432.webp",
      "IMG_6456.webp",
      "IMG_6480.webp",
      "IMG_7154.webp",
      "IMG_7252.webp"
    ],
    classes: [
      "PRO06336.webp",
      "PRO06601.webp",
      "PRO06780.webp",
      "PRO06927.webp",
      "PRO07651.webp",
      "PRO07751.webp"
    ],
    events: [
      "KIR02768.webp",
      "PRO01170.webp",
      "PRO01358.webp",
      "PRO01448.webp",
      "PRO03669.webp",
      "PRO07416.webp",
      "PRO07522.webp",
      "PRO07845.webp",
      "PRO07918.webp",
      "PRO08295.webp"
    ]
  }
};

// Экспортируем данные кампусов глобально для использования в campusSlider.js
window.campusNames = campusNames;
window.categoryFolders = categoryFolders;
window.categoryFoldersTashkent = categoryFoldersTashkent;
window.campusGalleryImages = campusGalleryImages;

function getLockedCampusSlug() {
  const root = document.querySelector("[data-secondary-campus-gallery][data-locked-campus]");
  return root ? root.getAttribute("data-locked-campus") : null;
}

// Функция для получения текущего выбранного кампуса
function getCurrentCampus() {
  const lockedCampus = getLockedCampusSlug();
  if (lockedCampus) return lockedCampus;

  if (!selectedCampus) {
    const curCountryEl = document.getElementById('curCountry');
    const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
    return isUzbekistanRegion ? "tashkent" : "spb";
  }
  const campusText = selectedCampus.textContent.trim();
  for (const [id, name] of Object.entries(campusNames)) {
    if (name === campusText) {
      return id;
    }
  }
  const curCountryEl = document.getElementById('curCountry');
  const isUzbekistanRegion = curCountryEl && (curCountryEl.textContent.trim() === 'Узбекистан' || curCountryEl.textContent.trim() === 'Uzbekistan');
  return isUzbekistanRegion ? "tashkent" : "spb"; // По умолчанию
}

// Функции updateCampusSlider и loadCampusImages вынесены в components/campusSlider.js

function openCampusModal() {
  if (campusModal) {
    campusModal.classList.add("open");
    if (campusSelectorBtn) campusSelectorBtn.classList.add("active");
  }
}

function closeCampusModal() {
  if (campusModal) {
    campusModal.classList.remove("open");
    if (campusSelectorBtn) {
      campusSelectorBtn.classList.remove("active");
      campusSelectorBtn.classList.remove("menu-open");
    }
    // Активируем кнопку "Территория" по умолчанию после закрытия модального окна только если нет активных кнопок табов
    const hasActiveTab = Array.from(campusTabButtons).some(btn => btn.classList.contains("active"));
    if (!hasActiveTab) {
      const territoryBtn = getTerritoryCampusTabButton();
      if (territoryBtn) {
        territoryBtn.classList.add("active");
      }
    }
  }
}

// Функция синхронизации выбора города между всеми блоками
function renderBlock14ReviewsFromCms(campusId) {
  const staffSection = document.querySelector('[data-landing-staff-js]') || document;
  const reviewsSlides = staffSection.querySelector('#reviewsSlides');
  const reviewsSection = staffSection.querySelector('#block14ReviewsSection');
  const reviewsByCampus = window.cmsTeachersReviewsByCampus || {};

  if (!reviewsSlides || !reviewsByCampus || typeof reviewsByCampus !== 'object') return;

  const reviewsData = Array.isArray(reviewsByCampus[campusId]) ? reviewsByCampus[campusId] : [];
  if (!reviewsData.length) {
    reviewsSlides.innerHTML = '';
    if (reviewsSection) reviewsSection.style.display = 'none';
    return;
  }

  if (reviewsSection) reviewsSection.style.display = '';
  const locale = window.cmsLocale || '';
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
  const expandText = (t && t.review_expand) ? t.review_expand : 'Развернуть';

  reviewsSlides.innerHTML = reviewsData.map((item) => `
    <a class="review_card" href="${item.slug ? `${locale}teachers/${item.slug}/` : 'javascript:void(0)'}" itemscope itemtype="https://schema.org/Review">
      <div class="review_top">
        <img src="${item.image}" alt="${item.name}" class="review_avatar" itemscope itemtype="https://schema.org/ImageObject"/>
        <div class="review_header">
          <div itemprop="author" itemscope itemtype="https://schema.org/Person">
            <h3 class="review_name"><span itemprop="name">${item.name}</span></h3>
            <p class="review_position"><span itemprop="jobTitle">${item.position}</span></p>
          </div>
        </div>
      </div>
      <p class="review_text" itemprop="reviewBody">${item.text || ''}</p>
      <button class="review_expand" type="button">${expandText}</button>
    </a>
  `).join('');
}

// Стоимость вступительного тестирования по кампусам (обновляется при выборе кампуса)
var TESTING_FEES = {
  skolkovo: { ru: '30 000 ₽', en: '30,000 RUB' },
  gorki:    { ru: '30 000 ₽', en: '30,000 RUB' },
  moscow:   { ru: '20 000 ₽', en: '20,000 RUB' },
  spb:      { ru: '15 000 ₽', en: '15,000 RUB' },
  tashkent: { ru: '750 000 сум', en: '750,000 UZS' }
};
var TESTING_FEE_NAMES = {
  ru: { skolkovo: 'Сколково', gorki: 'Горки', moscow: 'Москва', spb: 'Санкт-Петербург', tashkent: 'Ташкент' },
  en: { skolkovo: 'Skolkovo', gorki: 'Gorki', moscow: 'Moscow', spb: 'Saint Petersburg', tashkent: 'Tashkent' }
};
function testingFeeLabelFor(campusId, lang) {
  var fee = TESTING_FEES[campusId];
  if (!fee) return '';
  var l = (lang === 'en') ? 'en' : 'ru';
  var name = (TESTING_FEE_NAMES[l] && TESTING_FEE_NAMES[l][campusId]) || campusId;
  return name + ' — ' + (fee[l] || fee.ru);
}
function updateTestingFee(campusId, campusName, lang) {
  var text = testingFeeLabelFor(campusId, lang);
  if (!text) return;
  document.querySelectorAll('[data-testing-fee]').forEach(function (el) {
    el.textContent = text;
  });
}
window.testingFeeLabelFor = testingFeeLabelFor;
window.updateTestingFee = updateTestingFee;
function initTestingFee() {
  var els = document.querySelectorAll('[data-testing-fee]');
  if (!els.length) return;
  var lang = localStorage.getItem('siteLanguage') || 'ru';
  var uz = /\/[a-z]{2}-uz(\/|$)/i.test(location.pathname);
  try { var m = document.cookie.match(/(?:^|;\s*)_?cambridge_region=([^;]+)/); if (m && !uz) uz = /uzb|узб/i.test(decodeURIComponent(m[1])); } catch (e) {}
  var campus = uz ? 'tashkent' : 'gorki';
  els.forEach(function (el) { if (!el.textContent.trim()) el.textContent = testingFeeLabelFor(campus, lang); });
}
if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initTestingFee); } else { initTestingFee(); }

function syncCampusSelection(campusId) {
  const lockedCampus = getLockedCampusSlug();
  if (lockedCampus) {
    campusId = lockedCampus;
  }

  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;

  // Получаем название города с учетом языка
  let campusName = campusNames[campusId] || campusId;
  if (t) {
    const campusNameMap = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    if (campusNameMap[campusId]) {
      campusName = campusNameMap[campusId];
    }
  }

  // Стоимость тестирования для выбранного кампуса
  updateTestingFee(campusId, campusName, lang);

  // Block5 - обновляем selectedCampus
  const selectedCampus = document.getElementById("selectedCampus");
  if (selectedCampus) {
    selectedCampus.textContent = campusName;
  }

  // Block12 - обновляем block12SelectedCampus и кнопки
  const block12SelectedCampus = document.getElementById("block12SelectedCampus");
  if (block12SelectedCampus) {
    block12SelectedCampus.textContent = campusName;
  }
  const block12CampusButtons = document.querySelectorAll('.block12_campus_btn');
  block12CampusButtons.forEach(btn => {
    btn.classList.remove('active');
    if (btn.getAttribute('data-campus') === campusId) {
      btn.classList.add('active');
    }
  });

  // Начальная школа: селектор кампуса в block12 — опции .block12_campus_option (не кнопки)
  document.querySelectorAll('.block12_campus_option').forEach((opt) => {
    const active = opt.getAttribute('data-campus') === campusId;
    opt.classList.toggle('active', active);
    opt.classList.toggle('selected', active);
  });

  // Block14 - обновляем block14SelectedCampus и кнопки (все селекторы объединены)
  let block14CampusName = campusNames[campusId] || campusId;
  if (t) {
    const campusNameMap = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    if (campusNameMap[campusId]) {
      block14CampusName = campusNameMap[campusId];
    }
  }
  const block14SelectedCampus = document.getElementById("block14SelectedCampus");
  if (block14SelectedCampus) {
    block14SelectedCampus.textContent = block14CampusName;
  }
  const block14SelectedCampusMobile = document.getElementById("block14SelectedCampusMobile");
  if (block14SelectedCampusMobile) {
    block14SelectedCampusMobile.textContent = block14CampusName;
  }
  const block14CampusButtons = document.querySelectorAll('.block14_campus_btn');
  block14CampusButtons.forEach(btn => {
    btn.classList.remove('active');
    if (btn.getAttribute('data-campus') === campusId) {
      btn.classList.add('active');
    }
  });

  document.querySelectorAll('.block14_campus_option').forEach((opt) => {
    const active = opt.getAttribute('data-campus') === campusId;
    opt.classList.toggle('active', active);
    opt.classList.toggle('selected', active);
  });

  // Block20 - обновляем block20SelectedCampus и кнопки
  const block20SelectedCampus = document.getElementById("block20SelectedCampus");
  if (block20SelectedCampus) {
    block20SelectedCampus.textContent = campusName;
  }

  const block20CampusButtons = document.querySelectorAll('.block20_campus_btn');
  block20CampusButtons.forEach(btn => {
    btn.classList.remove('active');
    if (btn.getAttribute('data-campus') === campusId) {
      btn.classList.add('active');
    }
  });

  // Устанавливаем год 2025-2026 по умолчанию при изменении кампуса
  const block12SelectedYear = document.getElementById('block12SelectedYear');
  if (block12SelectedYear) {
    const currentLang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[currentLang] ? translations[currentLang] : null;
    const yearText = t && t.block12_year ? t.block12_year : (currentLang === 'en' ? 'year' : 'год');
    const currentYear = window.block12CurrentYear || '2025-2026';
    block12SelectedYear.textContent = currentYear + ' ' + yearText;
  }

  // Обновляем контент блоков, если функции доступны
  // Block12 - обновляем цены (функции доступны глобально)
  if (typeof toggleBlock12Prices === 'function') {
    const currentYear = window.block12CurrentYear || '2025-2026';
    toggleBlock12Prices(campusId, currentYear);
    if (typeof updateBlock12PricesForYear === 'function') {
      updateBlock12PricesForYear(currentYear, campusId);
    }
  }

  // Block12 - обновляем изображение кампуса в новой структуре block12_text
  const block12TextCampusImage = document.getElementById('block12TextCampusImage');
  const block12TextCampusName = document.getElementById('block12TextCampusName');

  // Получаем данные из CMS, если доступны
  let imagePath = campusImages[campusId];
  let captionText = campusCaptions[campusId] || `Кампус ${campusId}`;

  const stripCampusPrefix = (name) => (name || '').replace(/<br\s*\/?>/gi, ' ').trim().replace(/^(Кампус |Campus )/i, '');
  if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
    const campusFromCMS = window.campusesFromCMS.find(c => c.slug === campusId || c.id.toString() === campusId);
    if (campusFromCMS) {
      if (campusFromCMS.picture) {
        imagePath = campusFromCMS.picture;
      }
      const lang = localStorage.getItem('siteLanguage') || 'ru';
      const campusName = stripCampusPrefix(lang === 'en' ? campusFromCMS.name_en : campusFromCMS.name_ru);
      captionText = lang === 'en' ? `Campus ${campusName}` : `Кампус ${campusName}`;
    }
  }

  if (block12TextCampusImage && imagePath) {
    // Определяем правильный путь в зависимости от текущей страницы
    const currentPath = window.location.pathname;
    // Если мы на странице детского сада или другой подстранице, используем относительный путь
    if (currentPath.includes('/kindergarten/') || currentPath.includes('/school/') || currentPath.match(/\/[^\/]+\/index\.html/)) {
      imagePath = '../' + imagePath;
    }
    block12TextCampusImage.src = imagePath;
  }

  if (block12TextCampusName) {
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;

    // Если нет данных из CMS, используем переводы
    if (!captionText || captionText === `Кампус ${campusId}`) {
      if (t && t[`campus_name_${campusId}`]) {
        const cleanName = stripCampusPrefix(t[`campus_name_${campusId}`]);
        captionText = lang === 'en' ? `Campus ${cleanName}` : `Кампус ${cleanName}`;
      }
    }

    block12TextCampusName.textContent = captionText;
  }

  // Block12 - обновляем ссылку на страницу кампуса (иконка i)
  const block12TextCampusInfoLink = document.getElementById('block12TextCampusInfoLink');
  if (block12TextCampusInfoLink) {
    const locale = block12TextCampusInfoLink.getAttribute('data-locale') || window.location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\//)?.[0] || '/ru-ru/';
    block12TextCampusInfoLink.href = locale + 'campuses/' + campusId + '/';
    block12TextCampusInfoLink.setAttribute('data-campus', campusId);
  }

  // Block5 — на /campuses/:slug/ галерея уже отрендерена сервером, не перезагружаем из sync
  if (!lockedCampus) {
    if (typeof window.loadCampusImages === 'function') {
      window.loadCampusImages(campusId, "tgn");
    } else if (typeof loadCampusImages === 'function') {
      loadCampusImages(campusId, "tgn");
    }
  }

  // Block14 - обновляем преподавателей и отзывы
  if (typeof window.applyTeachers === 'function') {
    window.applyTeachers(campusId);
  } else if (typeof applyTeachers === 'function') {
    applyTeachers(campusId);
  }
  if (typeof window.updateBlock14SelectorDisplay === 'function') {
    window.updateBlock14SelectorDisplay(campusId);
  }
  if (typeof window.updateReviewsForCampus === 'function') {
    window.updateReviewsForCampus(campusId);
  }
  // Internal block14: гарантируем рендер строго по выбранному кампусу (без подмены по региону).
  renderBlock14ReviewsFromCms(campusId);
  if (typeof window.filterParentReviewsByCampus === 'function') {
    window.filterParentReviewsByCampus(campusId);
  }

  // Фильтруем отзывы родителей по выбранному кампусу
  if (typeof window.filterParentReviewsByCampus === 'function') {
    window.filterParentReviewsByCampus(campusId);
  }

  // Сохраняем текущий кампус для translatePage (на странице детсада нет .block20_campus_btn)
  window.currentBlock20Campus = campusId;

  // Расписание (учебный процесс): одна картинка на страницу + кампус, синхронизация с теми же селекторами кампуса
  document.querySelectorAll('img[data-timetable-tier]').forEach((img) => {
    const tier = img.getAttribute('data-timetable-tier');
    if (!tier || !campusId) return;
    img.src = `/landing_2025/src/img/timetables/${tier}/${campusId}.webp`;
  });

  // Block20 - обновляем контакты
  setTimeout(() => {
    if (typeof window.updateCampusInfo === 'function') {
      window.updateCampusInfo(campusId);
    }
  }, 100);
}

function selectCampus(campusId) {
  // Используем переводы в зависимости от текущего языка
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  let campusName = campusNames[campusId] || campusId;

  // Если есть переводы, используем их
  if (typeof translations !== 'undefined' && translations[lang]) {
    const t = translations[lang];
    const campusNameMap = {
      'skolkovo': t.campus_name_skolkovo,
      'moscow': t.campus_name_moscow,
      'gorki': t.campus_name_gorki,
      'spb': t.campus_name_spb,
      'tashkent': t.campus_name_tashkent
    };
    if (campusNameMap[campusId]) {
      campusName = campusNameMap[campusId];
    }
  }

  // Синхронизируем выбор города во всех блоках
  syncCampusSelection(campusId);

  if (selectedCampus) {
    selectedCampus.textContent = campusName;
  }
  // Закрываем модальное окно, но оставляем кнопку активной
  if (campusModal) {
    campusModal.classList.remove("open");
  }
  // Убираем active с кнопки выбора кампуса после выбора
  if (campusSelectorBtn) {
    campusSelectorBtn.classList.remove("active");
    campusSelectorBtn.classList.remove("menu-open");
  }
  // Убираем active со всех остальных кнопок (Территория, Интерьер и т.д.)
  campusTabButtons.forEach((btn) => {
    btn.classList.remove("active");
  });

  const territoryBtn = getTerritoryCampusTabButton();
  if (territoryBtn) {
    territoryBtn.classList.add("active");
  }
  // loadCampusImages вызывается в syncCampusSelection
}

// Экспортируем функции глобально (после определения всех функций)
window.syncCampusSelection = syncCampusSelection;
window.selectCampus = selectCampus;
window.getCurrentCampus = getCurrentCampus;
window.getLockedCampusSlug = getLockedCampusSlug;
// initHeroSlider экспортируется в components/heroSlider.js

// Код формы скачивания брошюры вынесен в forms/downloadBrochureForm.js

// Функция для обновления max-height фона в block8
// После 1440px max-height фиксируется на значении для 1440px
let maxBackgroundHeight1440 = null;

function updateBlock8BackgroundHeight() {
  const block8 = document.querySelector('.block8');
  const containerCard = document.querySelector('.block8 .container_card');

  if (!block8 || !containerCard) return;

  const block8Rect = block8.getBoundingClientRect();
  const windowWidth = window.innerWidth;

  // Получаем высоту контейнера
  const containerHeight = containerCard.offsetHeight;

  // Если высота еще не определена, откладываем выполнение
  if (containerHeight === 0) {
    setTimeout(updateBlock8BackgroundHeight, 100);
    return;
  }

  // Получаем позицию container_card относительно block8
  const containerCardRect = containerCard.getBoundingClientRect();
  const containerCardTop = containerCardRect.top - block8Rect.top;

  // Вычисляем позицию середины container_card (это высота фона)
  const containerCardMiddle = containerCardTop + (containerHeight / 2);

  // Если ширина окна >= 1440px и мы еще не сохранили значение для 1440px
  if (windowWidth >= 1440 && maxBackgroundHeight1440 === null) {
    // Сохраняем высоту фона при достижении 1440px
    maxBackgroundHeight1440 = containerCardMiddle;
  }

  // Если ширина окна < 1440px, сбрасываем сохраненное значение
  if (windowWidth < 1440) {
    maxBackgroundHeight1440 = null;
  }

  // Устанавливаем max-height только если мы на >= 1440px и значение сохранено
  if (windowWidth >= 1440 && maxBackgroundHeight1440 !== null) {
    block8.style.setProperty('--background-max-height', `${maxBackgroundHeight1440}px`);
  } else {
    block8.style.setProperty('--background-max-height', 'none');
  }
}

// Функция для обновления высоты белого фона в block8 при 768px
function updateBlock8WhiteBackground() {
  if (window.innerWidth > 768) {
    const block8 = document.querySelector('.block8');
    if (block8) {
      block8.style.setProperty('--white-bg-height', '0px');
    }
    return;
  }

  const block8 = document.querySelector('.block8');
  const containerCard = document.querySelector('.block8 .container_card');

  if (!block8 || !containerCard) return;

  // Находим все card_body_red в последнем ряду (нижние карточки)
  const allCards = containerCard.querySelectorAll('.card_school');
  if (allCards.length === 0) return;

  // При grid с 2 колонками нижний ряд начинается с 3-й карточки (индекс 2)
  // Если карточек меньше 3, берем последние карточки
  const lastRowStartIndex = allCards.length > 2 ? allCards.length - 2 : 0;
  const lastRowCards = Array.from(allCards).slice(lastRowStartIndex);

  if (lastRowCards.length === 0) return;

  // Находим card_body_red в нижних карточках
  let maxCardBodyRedHeight = 0;
  lastRowCards.forEach(card => {
    const cardBodyRed = card.querySelector('.card_body_red');
    if (cardBodyRed) {
      const height = cardBodyRed.offsetHeight;
      if (height > maxCardBodyRedHeight) {
        maxCardBodyRedHeight = height;
      }
    }
  });

  // Вычисляем половину высоты + небольшой отступ для точного позиционирования
  const halfHeight = maxCardBodyRedHeight * 0.6;

  // Устанавливаем CSS переменную
  block8.style.setProperty('--white-bg-height', `${halfHeight}px`);
}

// Обновляем при загрузке страницы
function initBlock8BackgroundOnLoad() {
  requestAnimationFrame(() => {
    setTimeout(() => {
      updateBlock8BackgroundHeight();
      updateBlock8WhiteBackground();
      setTimeout(() => {
        updateBlock8BackgroundHeight();
        updateBlock8WhiteBackground();
      }, 200);
    }, 100);
  });
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initBlock8BackgroundOnLoad);
} else {
  initBlock8BackgroundOnLoad();
}

// Также обновляем после полной загрузки страницы
window.addEventListener('load', () => {
  setTimeout(() => {
    updateBlock8BackgroundHeight();
    updateBlock8WhiteBackground();
  }, 100);
});

// Обновляем при изменении размера окна
let resizeTimer;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    // При переходе через 1440px сбрасываем фиксированное значение
    const windowWidth = window.innerWidth;
    if (windowWidth < 1440) {
      maxBackgroundHeight1440 = null;
    }
    updateBlock8BackgroundHeight();
    updateBlock8WhiteBackground();
  }, 100);
});

// Обновляем при изменении содержимого
const observer = new MutationObserver(() => {
  updateBlock8BackgroundHeight();
  updateBlock8WhiteBackground();
});

function initBlock8MutationObserver() {
  const block8 = document.querySelector('.block8');
  if (block8) {
    observer.observe(block8, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initBlock8MutationObserver);
} else {
  initBlock8MutationObserver();
}

// ============================================
// АКТИВАЦИЯ ПЕРВОЙ КАРТОЧКИ В BLOCK8 ПО УМОЛЧАНИЮ
// ============================================
(function () {
  function initBlock8Cards() {
    const containerCard = document.querySelector('.block8 .container_card');
    if (!containerCard) return;

    const cards = containerCard.querySelectorAll('.card_school');
    if (cards.length === 0) return;

    // НЕ устанавливаем первую карточку как активную по умолчанию
    // Убираем активный класс со всех карточек при инициализации
    cards.forEach(card => {
      card.classList.remove('active');
    });

    // Добавляем обработчики кликов для всех карточек
    cards.forEach(card => {
      // Удаляем старый обработчик, если есть
      const link = card.closest('.card_school_link');
      if (link) {
        // Сохраняем оригинальный href
        const originalHref = link.getAttribute('href') || '';
        const isAnchor = originalHref.startsWith('#');

        // Добавляем обработчик клика
        link.addEventListener('click', (e) => {
          if (isAnchor) {
            e.preventDefault();

            // Убираем активный класс со всех карточек
            cards.forEach(c => c.classList.remove('active'));

            // Добавляем активный класс к кликнутой карточке
            card.classList.add('active');

            // Опционально: можно добавить плавную прокрутку к якорю
            if (originalHref && originalHref.startsWith('#')) {
              const targetElement = document.querySelector(originalHref);
              if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
            }
            // если не якорь — переход на страницу произойдёт
          }
        });
      }
    });
  }

  // Инициализация при загрузке страницы
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(initBlock8Cards, 100);
    });
  } else {
    setTimeout(initBlock8Cards, 100);
  }

  // Также инициализируем при полной загрузке страницы
  window.addEventListener('load', () => {
    setTimeout(initBlock8Cards, 100);
  });
})();

// ============================================
// Код блока 12 вынесен в components/priceSlider.js
// ============================================

// ============================================
// ВАЛИДАЦИЯ ФОРМ form_hover
// ============================================

// Функция для генерации случайного антибота
function generateAntibot() {
  const num1 = Math.floor(Math.random() * 50) + 10; // от 10 до 59
  const num2 = Math.floor(Math.random() * num1); // от 0 до num1-1
  const answer = num1 - num2;
  return { num1, num2, answer };
}

// Делаем функцию глобально доступной
window.generateAntibot = generateAntibot;

// Функция для обновления текста антибота
// При <= 768px CSS скрывает ::before (убирает "Антибот:"), ::after показывает вопрос из data-question
// При > 768px показывается обычный текст на одной строке (без br, так как capcha_break скрыт)
function updateAntibotLabel(label, antibot) {
  if (!label || !antibot) return;

  // Получаем текущий язык и переводы
  const lang = localStorage.getItem('siteLanguage') || 'ru';
  const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;

  // Используем переводы, если доступны, иначе fallback на русский
  let questionText;
  if (t && t.antibot_question) {
    questionText = t.antibot_question
      .replace('{num1}', antibot.num1)
      .replace('{num2}', antibot.num2);
  } else {
    // Fallback на русский, если переводы недоступны
    questionText = `Сколько будет ${antibot.num1} - ${antibot.num2}?`;
  }

  label.setAttribute('data-question', questionText);

  // Сохраняем span.request если он есть
  const requestSpan = label.querySelector('.request');
  const requestHtml = requestSpan ? requestSpan.outerHTML : '';

  // Устанавливаем текст вопроса с сохранением span.request
  label.innerHTML = `${questionText}${requestHtml}`;
}

// Делаем функцию глобально доступной
window.updateAntibotLabel = updateAntibotLabel;

// Инициализация антиботов для обеих форм
let antibot1 = generateAntibot();
let antibot2 = generateAntibot();

function initFormHoverAntibotLabels() {
  // Инициализация антибота для form_hover_a
  const captchaLabel1 = document.querySelector('.form_hover_a .capcha_label');
  if (captchaLabel1) {
    antibot1 = generateAntibot();
    updateAntibotLabel(captchaLabel1, antibot1);
  }

  // Инициализация антибота для form_hover_b
  const captchaLabel2 = document.querySelector('.form_hover_b .capcha_label');
  if (captchaLabel2) {
    antibot2 = generateAntibot();
    updateAntibotLabel(captchaLabel2, antibot2);
  }
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initFormHoverAntibotLabels);
} else {
  initFormHoverAntibotLabels();
}

// При изменении размера окна обновляем текст антибота, если нужно
window.addEventListener('resize', function () {
  const captchaLabel1 = document.querySelector('.form_hover_a .capcha_label');
  const captchaLabel2 = document.querySelector('.form_hover_b .capcha_label');

  if (captchaLabel1 && antibot1) {
    updateAntibotLabel(captchaLabel1, antibot1);
  }
  if (captchaLabel2 && antibot2) {
    updateAntibotLabel(captchaLabel2, antibot2);
  }
});

// Обработчик события submit для form_hover_a (первая форма)
const formHoverA = document.querySelector('.form_hover_a');

const antibotLabel1 = document.getElementById('antibotLabel1');
const antibotLabel2 = document.getElementById('antibotLabel2');

if (antibotLabel1) {
  updateAntibotLabel(antibotLabel1, antibot1);
}

if (antibotLabel2) {
  updateAntibotLabel(antibotLabel2, antibot2);
}

// Функция для обновления всех меток антибота при изменении размера окна
function updateAllAntibotLabels() {
  // Обновляем капчи в формах form_hover_a и form_hover_b
  const captchaLabel1 = document.querySelector('.form_hover_a .capcha_label');
  if (captchaLabel1 && typeof antibot1 !== 'undefined' && antibot1) {
    updateAntibotLabel(captchaLabel1, antibot1);
  }

  const captchaLabel2 = document.querySelector('.form_hover_b .capcha_label');
  if (captchaLabel2 && typeof antibot2 !== 'undefined' && antibot2) {
    updateAntibotLabel(captchaLabel2, antibot2);
  }

  // Обновляем капчи по ID
  if (typeof antibotLabel1 !== 'undefined' && antibotLabel1 && typeof antibot1 !== 'undefined') {
    updateAntibotLabel(antibotLabel1, antibot1);
  }
  if (typeof antibotLabel2 !== 'undefined' && antibotLabel2 && typeof antibot2 !== 'undefined') {
    updateAntibotLabel(antibotLabel2, antibot2);
  }
  if (typeof antibotLabel3 !== 'undefined' && antibotLabel3 && typeof antibot3 !== 'undefined') {
    updateAntibotLabel(antibotLabel3, antibot3);
  }
  if (typeof antibotLabel4 !== 'undefined' && antibotLabel4 && typeof antibot4 !== 'undefined') {
    updateAntibotLabel(antibotLabel4, antibot4);
  }
  if (typeof antibotLabel20 !== 'undefined' && antibotLabel20 && typeof antibot20 !== 'undefined') {
    updateAntibotLabel(antibotLabel20, antibot20);
  }

  // Обновляем все капчи с классом .capcha (для других форм)
  const allCapchaLabels = document.querySelectorAll('.capcha:not(.capcha_label)');
  allCapchaLabels.forEach(label => {
    // Пропускаем block7 - для него есть специальная обработка
    if (label.id === 'antibotLabelBlock7') {
      return;
    }

    const dataQuestion = label.getAttribute('data-question');
    if (dataQuestion) {
      // Извлекаем числа из data-question
      const match = dataQuestion.match(/(\d+)\s*(?:-|минус|minus)\s*(\d+)/i);
      if (match) {
        const num1 = parseInt(match[1]);
        const num2 = parseInt(match[2]);
        const antibot = { num1, num2 };
        updateAntibotLabel(label, antibot);
      }
    }
  });
}

// Экспортируем функцию глобально для использования в translatePage
window.updateAllAntibotLabels = updateAllAntibotLabels;

// Обработчик resize для обновления текста антибота
let antibotResizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(antibotResizeTimeout);
  antibotResizeTimeout = setTimeout(() => {
    updateAllAntibotLabels();
  }, 100);
});

// Обновляем все метки антибота при загрузке страницы
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(() => {
      updateAllAntibotLabels();
    }, 200);
  });
} else {
  setTimeout(() => {
    updateAllAntibotLabels();
  }, 200);
}

window.addEventListener('load', () => {
  setTimeout(() => {
    updateAllAntibotLabels();
  }, 100);
});

// Функция валидации телефона
// Функция validatePhone вынесена в utils/validation.js

// Функция обновления ограничений для полей телефона
function updatePhoneInputsLimits(regionName, scopeWrapper) {
  // scopeWrapper — обновить только эту форму (например после смены кода в селекторе)
  const allPhoneWrappers = scopeWrapper
    ? [scopeWrapper.classList && scopeWrapper.classList.contains('phone_wrapper')
      ? scopeWrapper
      : (scopeWrapper.closest && scopeWrapper.closest('.phone_wrapper'))].filter(Boolean)
    : document.querySelectorAll('.phone_wrapper');

  allPhoneWrappers.forEach(wrapper => {
    // Пропускаем block7
    if (wrapper.closest('.block7')) {
      return;
    }

    const phoneInput = wrapper.querySelector('input[type="tel"]');
    const phoneCodeEl = wrapper.querySelector('.phone-code');

    if (phoneInput) {
      // Определяем код страны в этом конкретном wrapper
      let code = phoneCodeEl ? phoneCodeEl.textContent.trim() : null;

      // Всегда определяем регион из параметра или cookie, чтобы правильно установить placeholder
      let currentRegionName = regionName || 'Россия';
      try {
        const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
          ? window.getCookie(window.COOKIE_NAME)
          : null;
        if (saved) {
          const r = JSON.parse(saved);
          currentRegionName = r.name;
        }
      } catch (e) {
        // Используем значение по умолчанию
      }
      const isUzbekistan = currentRegionName === 'Узбекистан' || currentRegionName === 'Uzbekistan';

      // Если код страны отсутствует, используем регион как fallback.
      // Не перетираем уже выбранный код по региону, чтобы не расходиться с phoneFlagSelector.
      if (!code) {
        code = isUzbekistan ? '+998' : '+7';
      }

      if (phoneCodeEl && !phoneCodeEl.textContent.trim()) {
        phoneCodeEl.textContent = code;
      }

      // Получаем данные страны из countryCodes.js
      const country = window.getCountryByCode && window.getCountryByCode(code);
      const maxDigits = country ? country.pattern.max : 10;
      const placeholder = country ? country.placeholder : '999 999 99 99';
      const maxLength = window.getMaxFormattedLength && window.getMaxFormattedLength(code) || 20;

      // Устанавливаем maxlength для ограничения ввода (учитываем пробелы)
      phoneInput.setAttribute('maxlength', maxLength);

      // Не перезаписываем placeholder для полей с intl-tel-input (они управляются отдельно)
      // Проверяем наличие intl-tel-input по наличию _iti или по ID полей с intl-tel-input
      const hasIntlTelInput = phoneInput._iti ||
        phoneInput.id === 'phone' ||
        phoneInput.id === 'phone2' ||
        phoneInput.id === 'phone3' ||
        phoneInput.id === 'phone4';

      if (!hasIntlTelInput) {
        phoneInput.placeholder = placeholder;
      } else {
        // Для полей с intl-tel-input только сохраняем правильный placeholder в data-атрибут
        phoneInput.dataset.correctPlaceholder = placeholder;
      }

      phoneInput.dataset.countryCode = code;
      if (phoneInput.value) {
        const formattedValue = window.formatPhoneNumber && window.formatPhoneNumber(phoneInput.value, code);
        if (formattedValue && formattedValue !== phoneInput.value) {
          phoneInput.value = formattedValue;
        }
      }

      // Удаляем старый обработчик ограничения, если он есть
      if (phoneInput.dataset.limitHandler) {
        phoneInput.removeEventListener('input', phoneInput._limitHandler);
        phoneInput.removeEventListener('paste', phoneInput._pasteHandler);
      }

      // Создаем обработчик для ограничения ввода только цифрами
      const limitHandler = function (e) {
        let value = e.target.value.replace(/\D/g, ''); // Убираем все нецифровые символы

        // Определяем код страны по текущему коду
        const currentCode = e.target.closest('.phone_wrapper').querySelector('.phone-code')?.textContent.trim() || '+7';
        const currentCountry = window.getCountryByCode && window.getCountryByCode(currentCode);
        const currentMaxDigits = currentCountry ? currentCountry.pattern.max : 10;

        // Строго ограничиваем количество цифр
        if (value.length > currentMaxDigits) {
          value = value.slice(0, currentMaxDigits);
        }

        // Форматируем номер используя универсальную функцию
        const formatted = window.formatPhoneNumber && window.formatPhoneNumber(value, currentCode) || value;
        e.target.value = formatted;

        // Не триггерим input повторно, чтобы не вызывать рекурсию
        // // Вызываем событие input для обновления кнопки submit
        // e.target.dispatchEvent(new Event('input', { bubbles: true }));
      };

      phoneInput._limitHandler = limitHandler;
      phoneInput.addEventListener('input', limitHandler, { capture: false });
      phoneInput.dataset.limitHandler = 'true';

      // Добавляем обработчик для предотвращения вставки через paste
      const pasteHandler = function (e) {
        e.preventDefault();
        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
        let value = pastedText.replace(/\D/g, '');

        const currentCode = e.target.closest('.phone_wrapper').querySelector('.phone-code')?.textContent.trim() || '+7';
        const currentCountry = window.getCountryByCode && window.getCountryByCode(currentCode);
        const currentMaxDigits = currentCountry ? currentCountry.pattern.max : 10;

        if (value.length > currentMaxDigits) {
          value = value.slice(0, currentMaxDigits);
        }

        // Форматируем и устанавливаем значение
        const formatted = window.formatPhoneNumber && window.formatPhoneNumber(value, currentCode) || value;
        e.target.value = formatted;
      };

      phoneInput._pasteHandler = pasteHandler;
      phoneInput.addEventListener('paste', pasteHandler);
    }
  });
}

function syncStep2PhoneState(sourcePhoneId, sourceCodeId, sourceFlagId, targetPhoneId, targetCodeId, targetFlagId, targetSelectorId) {
  const sourcePhone = document.getElementById(sourcePhoneId);
  const sourceCodeEl = document.getElementById(sourceCodeId);
  const sourceFlagEl = document.getElementById(sourceFlagId);
  const sourceSelector = document.getElementById(`phoneFlagSelector${sourcePhoneId.replace(/^phone/, '')}`);
  const targetPhone = document.getElementById(targetPhoneId);
  const targetCodeEl = document.getElementById(targetCodeId);
  const targetFlagEl = document.getElementById(targetFlagId);
  const targetSelector = document.getElementById(targetSelectorId);

  if (!targetPhone || !targetCodeEl || !targetSelector) return;

  const code = String((sourceCodeEl?.textContent || targetCodeEl.textContent || '+7')).trim();
  const iso = String(sourceSelector?.dataset.selectedIso || targetSelector.dataset.selectedIso || '').trim();
  const country = window.getCountryByCode ? window.getCountryByCode(code) : null;

  targetCodeEl.textContent = code;
  targetSelector.dataset.selectedIso = iso;

  if (sourceFlagEl && targetFlagEl) {
    const clonedFlag = sourceFlagEl.cloneNode(true);
    clonedFlag.id = targetFlagEl.id;
    targetFlagEl.replaceWith(clonedFlag);
  }

  targetPhone.dataset.countryCode = code;
  if (country && country.placeholder) {
    targetPhone.placeholder = country.placeholder;
    targetPhone.dataset.correctPlaceholder = country.placeholder;
  }

  const sourcePhoneValue = sourcePhone ? sourcePhone.value : targetPhone.value;
  if (typeof window.formatPhoneNumber === 'function') {
    targetPhone.value = window.formatPhoneNumber(sourcePhoneValue || targetPhone.value || '', code);
  } else if (sourcePhoneValue) {
    targetPhone.value = sourcePhoneValue;
  }
}


// ============================================
// Код блока 12 вынесен в components/priceSlider.js
// ============================================
// ВАЛИДАЦИЯ ФОРМ form_hover
// ============================================

// Функция проверки антибота
function checkAntibot(userAnswer, correctAnswer) {
  if (!userAnswer || !userAnswer.trim()) return false;

  const answer = parseInt(userAnswer.trim(), 10);
  if (isNaN(answer)) return false;

  return answer === correctAnswer;
}

// Экспортируем функцию глобально для использования в других модулях
window.checkAntibot = checkAntibot;

// Функция обновления состояния кнопки
function updateSubmitButton(phoneInput, commentInput, submitBtn, itiInstance, correctAnswer) {
  if (!phoneInput || !commentInput || !submitBtn) return;

  const isPhoneValid = validatePhone(phoneInput, itiInstance);
  const isAntibotValid = checkAntibot(commentInput.value, correctAnswer);


  if (isPhoneValid && isAntibotValid) {
    submitBtn.disabled = false;
    submitBtn.style.opacity = '1';
    submitBtn.style.cursor = 'pointer';
  } else {
    submitBtn.disabled = true;
    submitBtn.style.opacity = '0.5';
    submitBtn.style.cursor = 'not-allowed';
  }
}
window.updateSubmitButton = updateSubmitButton;

// Экспортируем updatePhoneInputsLimits глобально для использования в phoneFlagSelector.js
window.updatePhoneInputsLimits = updatePhoneInputsLimits;

// После загрузки бандла: regionSelector мог вызвать applyRegion до этого файла — повторно вешаем лимиты
function runInitialUpdatePhoneInputsLimits() {
  try {
    updatePhoneInputsLimits();
  } catch (e) {
    /* ignore */
  }
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', runInitialUpdatePhoneInputsLimits);
} else {
  setTimeout(runInitialUpdatePhoneInputsLimits, 0);
}

// Инициализация валидации для первой формы
const phone1 = document.getElementById('phone');
const comment1 = document.getElementById('comment');
const submitBtn1 = document.getElementById('submitBtn1');

let iti1 = null;
if (phone1 && window.intlTelInput) {
  // Определяем регион при загрузке страницы
  let initialCountry = "ru";
  try {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : null;
    if (saved) {
      const r = JSON.parse(saved);
      if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') {
        initialCountry = "uz";
      }
    }
  } catch (e) {
    // Используем значение по умолчанию
  }

  iti1 = window.intlTelInput(phone1, {
    initialCountry: initialCountry,
    preferredCountries: ["ru", "uz"],
    nationalMode: false,
    formatOnDisplay: true,
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.6/build/js/utils.js",
  });

  // Сохраняем экземпляр iti в элементе для доступа извне
  phone1._iti = iti1;

  // Сохраняем правильный placeholder в data-атрибут
  const setCorrectPlaceholder = () => {
    if (iti1 && phone1) {
      try {
        const countryData = iti1.getSelectedCountryData();
        const countryCode = countryData ? countryData.dialCode : null;
        if (countryCode) {
          const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
          if (country && country.placeholder) {
            phone1.dataset.correctPlaceholder = country.placeholder;
            return country.placeholder;
          }
        }
      } catch (e) {
        // intl-tel-input еще не готов
      }
    }
    return null;
  };

  // Переопределяем setAttribute для перехвата всех изменений placeholder
  const originalSetAttribute = Element.prototype.setAttribute.bind(phone1);
  phone1.setAttribute = function (name, value) {
    if (name === 'placeholder') {
      // Всегда используем правильный placeholder, если он установлен
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        // Используем оригинальный setAttribute напрямую, чтобы избежать рекурсии
        Element.prototype.setAttribute.call(this, name, correctPlaceholder);
      } else {
        originalSetAttribute.call(this, name, value);
      }
    } else {
      originalSetAttribute.call(this, name, value);
    }
  };

  // Также переопределяем прямое присваивание placeholder
  let correctPlaceholderValue = null;
  Object.defineProperty(phone1, 'placeholder', {
    get: function () {
      return correctPlaceholderValue || this.getAttribute('placeholder') || '';
    },
    set: function (value) {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        correctPlaceholderValue = correctPlaceholder;
        Element.prototype.setAttribute.call(this, 'placeholder', correctPlaceholder);
      } else {
        correctPlaceholderValue = value;
        Element.prototype.setAttribute.call(this, 'placeholder', value);
      }
    },
    configurable: true,
    enumerable: true
  });

  // Обновляем правильный placeholder после инициализации
  const updatePhone1Placeholder = () => {
    const placeholder = setCorrectPlaceholder();
    if (placeholder) {
      // Используем прямое присваивание, которое вызовет наш setter
      phone1.placeholder = placeholder;
    }
  };

  // Обновляем placeholder несколько раз с задержкой
  setTimeout(() => updatePhone1Placeholder(), 300);
  setTimeout(() => updatePhone1Placeholder(), 800);
  setTimeout(() => updatePhone1Placeholder(), 1500);
  setTimeout(() => updatePhone1Placeholder(), 2500);
  setTimeout(() => updatePhone1Placeholder(), 4000);

  // Используем setInterval для постоянной проверки и восстановления placeholder
  const placeholderCheckInterval = setInterval(() => {
    const correctPlaceholder = phone1.dataset.correctPlaceholder;
    if (correctPlaceholder) {
      const currentPlaceholder = phone1.getAttribute('placeholder');
      if (currentPlaceholder !== correctPlaceholder) {
        phone1.placeholder = correctPlaceholder; // Используем setter
      }
    }
  }, 300);

  // Останавливаем проверку через 15 секунд (когда все должно быть загружено)
  setTimeout(() => {
    clearInterval(placeholderCheckInterval);
  }, 15000);

  // Обновление кнопки при изменении телефона
  phone1.addEventListener('input', () => {
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  });

  phone1.addEventListener('blur', () => {
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  });

  // Обновление placeholder при смене страны
  phone1.addEventListener('countrychange', () => {
    updatePhone1Placeholder(); // Вызываем нашу функцию обновления
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  });
}

if (comment1 && submitBtn1) {
  comment1.addEventListener('input', () => {
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  });

  comment1.addEventListener('blur', () => {
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  });
}

// Инициализация кнопки при загрузке
if (phone1 && comment1 && submitBtn1) {
  setTimeout(() => {
    updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
  }, 500);
}

// Инициализация валидации для второй формы
const phone2 = document.getElementById('phone2');
const comment2 = document.getElementById('comment2');
const submitBtn2 = document.getElementById('submitBtn2');

let iti2 = null;
if (phone2 && window.intlTelInput) {
  // Определяем регион при загрузке страницы
  let initialCountry = "ru";
  try {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : null;
    if (saved) {
      const r = JSON.parse(saved);
      if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') {
        initialCountry = "uz";
      }
    }
  } catch (e) {
    // Используем значение по умолчанию
  }

  iti2 = window.intlTelInput(phone2, {
    initialCountry: initialCountry,
    preferredCountries: ["ru", "uz"],
    nationalMode: false,
    formatOnDisplay: true,
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.6/build/js/utils.js",
  });

  // Сохраняем правильный placeholder в data-атрибут
  const setCorrectPlaceholder = () => {
    if (iti2 && phone2) {
      try {
        const countryData = iti2.getSelectedCountryData();
        const countryCode = countryData ? countryData.dialCode : null;
        if (countryCode) {
          const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
          if (country && country.placeholder) {
            phone2.dataset.correctPlaceholder = country.placeholder;
            return country.placeholder;
          }
        }
      } catch (e) {
        // intl-tel-input еще не готов
      }
    }
    return null;
  };

  // Переопределяем setAttribute для перехвата всех изменений placeholder
  // Сохраняем оригинальный setAttribute до того, как intl-tel-input может его изменить
  const originalSetAttribute = Element.prototype.setAttribute.bind(phone2);
  phone2.setAttribute = function (name, value) {
    if (name === 'placeholder') {
      // Всегда используем правильный placeholder, если он установлен
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        // Используем оригинальный setAttribute напрямую, чтобы избежать рекурсии
        Element.prototype.setAttribute.call(this, name, correctPlaceholder);
      } else {
        originalSetAttribute.call(this, name, value);
      }
    } else {
      originalSetAttribute.call(this, name, value);
    }
  };

  // Также переопределяем прямое присваивание placeholder
  let correctPlaceholderValue = null;
  Object.defineProperty(phone2, 'placeholder', {
    get: function () {
      return correctPlaceholderValue || this.getAttribute('placeholder') || '';
    },
    set: function (value) {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        correctPlaceholderValue = correctPlaceholder;
        Element.prototype.setAttribute.call(this, 'placeholder', correctPlaceholder);
      } else {
        correctPlaceholderValue = value;
        Element.prototype.setAttribute.call(this, 'placeholder', value);
      }
    },
    configurable: true,
    enumerable: true
  });

  // Обновляем правильный placeholder после инициализации
  const updatePhone2Placeholder = () => {
    const placeholder = setCorrectPlaceholder();
    if (placeholder) {
      // Используем прямое присваивание, которое вызовет наш setter
      phone2.placeholder = placeholder;
    }
  };

  // Обновляем placeholder несколько раз с задержкой
  setTimeout(() => updatePhone2Placeholder(), 300);
  setTimeout(() => updatePhone2Placeholder(), 800);
  setTimeout(() => updatePhone2Placeholder(), 1500);
  setTimeout(() => updatePhone2Placeholder(), 2500);
  setTimeout(() => updatePhone2Placeholder(), 4000);

  // Используем setInterval для постоянной проверки и восстановления placeholder
  const placeholderCheckInterval = setInterval(() => {
    const correctPlaceholder = phone2.dataset.correctPlaceholder;
    if (correctPlaceholder) {
      const currentPlaceholder = phone2.getAttribute('placeholder');
      if (currentPlaceholder !== correctPlaceholder) {
        phone2.placeholder = correctPlaceholder; // Используем setter
      }
    }
  }, 300);

  // Останавливаем проверку через 15 секунд (когда все должно быть загружено)
  setTimeout(() => {
    clearInterval(placeholderCheckInterval);
  }, 15000);

  // Обновление кнопки при изменении телефона
  phone2.addEventListener('input', () => {
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  });

  phone2.addEventListener('blur', () => {
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  });

  // Обновление placeholder при смене страны
  phone2.addEventListener('countrychange', () => {
    updatePhone2Placeholder();
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  });
}

if (comment2 && submitBtn2) {
  comment2.addEventListener('input', () => {
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  });

  comment2.addEventListener('blur', () => {
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  });
}

// Инициализация кнопки при загрузке
if (phone2 && comment2 && submitBtn2) {
  setTimeout(() => {
    updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
  }, 500);
}

// Функция отправки формы шага 1 (только телефон)
const submitStep1Form = (form, phoneInput, phoneCode, explicitContainerId = null) => {

  const formData = new FormData();

  window.callTouchHandlers?.handleForm(form); // CallTouch (see layouts/_calltouch.html)
  window.utmHandlers?.fillFormUtm(formData, 'request'); // append UTM (see javascripts/utils/utm-tags-handlers.js)

  // Добавляем только телефон и код страны
  const phoneValue = phoneInput.value.replace(/\D/g, '');
  if (phoneValue) {
    formData.append('request[parent_phone]', phoneValue);
    formData.append('request[parent_phone_code]', phoneCode);
  }

  // Добавляем request_kind_id из скрытого поля формы
  const requestKindId = form.querySelector('input[name="request[request_kind_id]"]')?.value;
  if (requestKindId) {
    formData.append('request[request_kind_id]', requestKindId);
  }

  // Добавляем form_name из data-атрибута или определяем по request_kind_id
  const formName = form.dataset.formName || 'Записаться на экскурсию';
  formData.append('form_name', formName);

  // ВАЖНО: Помечаем, что это шаг 1 (только телефон) - для создания сделки
  formData.append('form_step', '1');

  // Добавляем container_id для ответа
  let containerId = explicitContainerId;
  if (!containerId) {
    // Ищем контейнер внутри формы или в ближайшем родительском элементе
    containerId = form.querySelector('[id*="msgPlacer"]')?.id;
    if (!containerId) {
      // Если не нашли внутри формы, ищем в ближайшем родителе
      const formParent = form.closest('section') || form.parentElement;
      if (formParent) {
        containerId = formParent.querySelector('[id*="msgPlacer"]')?.id;
      }
    }
    // Если все еще не нашли, используем дефолт
    if (!containerId) {
      containerId = 'msgPlacerForm1Step1';
    }
  }
  formData.append('container_id', containerId);

  // CSRF токен
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
    form.querySelector('input[name="authenticity_token"]')?.value;
  formData.append('authenticity_token', csrfToken);

  const url = form.action || form.getAttribute('action');

  fetch(url, {
    method: 'POST',
    body: formData,
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': csrfToken,
      'Accept': 'text/javascript'
    },
    credentials: 'same-origin'
  })
    .then(response => {
      if (response.ok) {
        return response.text();
      } else {
        return response.text().then(text => {
          throw new Error('Ошибка отправки формы: ' + response.status);
        });
      }
    })
    .then(text => {
      // Выполняем JavaScript ответ от сервера
      // На шаге 1 finishApplyNowForm не вызывается, поэтому форма не сбросится
      const script = document.createElement('script');
      script.textContent = text;
      document.head.appendChild(script);
      document.head.removeChild(script);
    })
    .catch(error => {
      // Не показываем alert - форма все равно перейдет на шаг 2
    });
};

// Обработчики отправки форм - переход на вторую страницу
if (submitBtn1) {
  submitBtn1.addEventListener('click', (e) => {
    e.preventDefault();

    if (!validatePhone(phone1, iti1)) {
      alert('Пожалуйста, введите корректный номер телефона');
      return;
    }

    if (!checkAntibot(comment1.value, antibot1.answer)) {
      alert('Неверный ответ на вопрос антибота');
      // Генерируем новый антибот
      antibot1 = generateAntibot();
      if (antibotLabel1) {
        updateAntibotLabel(antibotLabel1, antibot1);
      }
      comment1.value = '';
      updateSubmitButton(phone1, comment1, submitBtn1, iti1, antibot1.answer);
      return;
    }

    // ВАЖНО: Сохраняем телефон ДО отправки формы, чтобы он не потерялся
    const phoneValue = phone1 ? phone1.value : '';
    const phoneCode1 = document.getElementById('phoneCode')?.textContent || '+7';

    // Получаем номер телефона без кода страны (начиная с 9) - ДО отправки формы
    let phoneNumber = '';
    if (phoneValue) {
      // Убираем все нецифровые символы
      const digits = phoneValue.replace(/\D/g, '');
      // Если номер начинается с 7 или 8, убираем первую цифру
      if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
        phoneNumber = digits.substring(1);
      } else if (digits.length > 0 && digits[0] === '9') {
        phoneNumber = digits;
      } else {
        phoneNumber = digits;
      }
    }

    // Переход на вторую страницу формы СРАЗУ, ДО отправки формы (используем форму, содержащую кнопку)
    const formStep1_1 = submitBtn1.closest('form')?.querySelector('.form_hover');
    const formStep2_1 = document.getElementById('formStep2_1');
    const phoneStep2_1 = document.getElementById('phone_step2_1');

    if (formStep1_1 && formStep2_1 && phoneStep2_1) {
      // ВАЖНО: Сохраняем значение телефона ПЕРЕД скрытием формы
      const phoneValueBeforeHide = phone1 ? phone1.value : '';
      const phoneRawBeforeHide = phone1 ? phone1.value.replace(/\D/g, '') : '';

      // Скрываем form_hover и показываем formStep2_1
      formStep1_1.style.display = 'none';
      formStep2_1.style.display = 'flex';

      // ВАЖНО: Восстанавливаем телефон ПОСЛЕ скрытия формы, если он был сброшен
      setTimeout(() => {
        const phoneValueAfterHide = phone1 ? phone1.value : '';
        const phoneRawAfterHide = phone1 ? phone1.value.replace(/\D/g, '') : '';

        if (phoneRawAfterHide !== phoneRawBeforeHide && phoneRawBeforeHide.length > 0) {
          if (phone1) {
            phone1.value = phoneValueBeforeHide;
            // Восстанавливаем через intlTelInput
            if (window.intlTelInput && phone1._iti) {
              try {
                const fullNumber = phone1._iti.getNumber(intlTelInputUtils.numberFormat.E164) || phoneValueBeforeHide;
                phone1._iti.setNumber(fullNumber);
              } catch (e) {
                // Используем прямое значение
              }
            }
          }
        }
      }, 50);

      // Копируем код страны и флаг ПЕРЕД установкой телефона
      const phoneCode1Copy = document.getElementById('phoneCode')?.textContent || '+7';
      const phoneFlagImg1 = document.getElementById('phoneFlagImg');
      const phoneCodeStep2_1 = document.getElementById('phoneCode_step2_1');
      const phoneFlagImgStep2_1 = document.getElementById('phoneFlagImg_step2_1');
      const phoneCodeHidden1 = document.getElementById('parent_phone_code_1');

      if (phoneCodeStep2_1) phoneCodeStep2_1.textContent = phoneCode1Copy;
      if (phoneFlagImgStep2_1 && phoneFlagImg1) {
        const clonedFlag1 = phoneFlagImg1.cloneNode(true);
        if (clonedFlag1) {
          clonedFlag1.id = phoneFlagImgStep2_1.id;
          phoneFlagImgStep2_1.replaceWith(clonedFlag1);
        }
      }
      if (phoneCodeHidden1) phoneCodeHidden1.value = phoneCode1Copy;

      // Устанавливаем телефон СРАЗУ, ДО инициализации phone_flag_selector
      phoneStep2_1.value = phoneNumber;

      // Инициализируем phone_flag_selector для step2_1 ПОСЛЕ установки телефона
      if (typeof initPhoneFlagSelectorStep2 === 'function') {
        initPhoneFlagSelectorStep2('phoneFlagSelector_step2_1', 'phoneModal_step2_1', 'phoneFlagImg_step2_1', 'phoneCode_step2_1');
        syncStep2PhoneState('phone', 'phoneCode', 'phoneFlagImg', 'phone_step2_1', 'phoneCode_step2_1', 'phoneFlagImg_step2_1', 'phoneFlagSelector_step2_1');
        // Восстанавливаем телефон после инициализации, если он был очищен
        setTimeout(() => {
          if (phoneStep2_1 && phoneStep2_1.value !== phoneNumber && phoneNumber) {
            phoneStep2_1.value = phoneNumber;
            phoneStep2_1.dispatchEvent(new Event('input', { bubbles: true }));
          }
          syncStep2PhoneState('phone', 'phoneCode', 'phoneFlagImg', 'phone_step2_1', 'phoneCode_step2_1', 'phoneFlagImg_step2_1', 'phoneFlagSelector_step2_1');
        }, 50);
      }

      // Триггерим событие input для обновления UI
      phoneStep2_1.dispatchEvent(new Event('input', { bubbles: true }));
      phoneStep2_1.dispatchEvent(new Event('change', { bubbles: true }));

      // Переводим элементы step2 формы
      if (typeof window.translateStep2Form === 'function') {
        window.translateStep2Form('formStep2_1');
      }
    }

    // ОТПРАВЛЯЕМ ФОРМУ ШАГА 1 ПОСЛЕ того, как телефон уже скопирован в шаг 2
    const form = phone1.closest('form');
    if (form) {
      submitStep1Form(form, phone1, phoneCode1);
    }
  });
}

if (submitBtn2) {
  submitBtn2.addEventListener('click', (e) => {
    e.preventDefault();

    if (!validatePhone(phone2, iti2)) {
      alert('Пожалуйста, введите корректный номер телефона');
      return;
    }

    if (!checkAntibot(comment2.value, antibot2.answer)) {
      alert('Неверный ответ на вопрос антибота');
      // Генерируем новый антибот
      antibot2 = generateAntibot();
      if (antibotLabel2) {
        updateAntibotLabel(antibotLabel2, antibot2);
      }
      comment2.value = '';
      updateSubmitButton(phone2, comment2, submitBtn2, iti2, antibot2.answer);
      return;
    }

    // ВАЖНО: Сохраняем телефон ДО отправки формы, чтобы он не потерялся
    const phoneValue2 = phone2 ? phone2.value : '';
    const phoneCode2 = document.getElementById('phoneCode2')?.textContent ||
      document.querySelectorAll('.phone-code')[1]?.textContent || '+7';

    // Получаем номер телефона без кода страны (начиная с 9) - ДО отправки формы
    let phoneNumber2 = '';
    if (phoneValue2) {
      // Убираем все нецифровые символы
      const digits = phoneValue2.replace(/\D/g, '');
      // Если номер начинается с 7 или 8, убираем первую цифру
      if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
        phoneNumber2 = digits.substring(1);
      } else if (digits.length > 0 && digits[0] === '9') {
        phoneNumber2 = digits;
      } else {
        phoneNumber2 = digits;
      }
    }

    // Переход на вторую страницу формы СРАЗУ, ДО отправки формы
    // Используем closest для корректной работы при нескольких формах на странице (дет.сад)
    const formStep1_2 = phone2.closest('form')?.querySelector('.form_hover');
    const formStep2_2 = document.getElementById('formStep2_2');
    const phoneStep2_2 = document.getElementById('phone_step2_2');

    if (formStep1_2 && formStep2_2 && phoneStep2_2) {
      formStep1_2.style.display = 'none';
      formStep2_2.style.display = 'flex';

      // Копируем код страны и флаг ПЕРЕД установкой телефона
      const phoneCode2Copy = document.getElementById('phoneCode2')?.textContent || document.querySelectorAll('.phone-code')[1]?.textContent || '+7';
      const phoneFlagImg2 = document.getElementById('phoneFlagImg2') || document.querySelectorAll('.phoneFlagImg')[1];
      const phoneCodeStep2_2 = document.getElementById('phoneCode_step2_2');
      const phoneFlagImgStep2_2 = document.getElementById('phoneFlagImg_step2_2');
      const phoneCodeHidden2 = document.getElementById('parent_phone_code_2');

      if (phoneCodeStep2_2) phoneCodeStep2_2.textContent = phoneCode2Copy;
      if (phoneFlagImgStep2_2 && phoneFlagImg2) {
        const clonedFlag2 = phoneFlagImg2.cloneNode(true);
        if (clonedFlag2) {
          clonedFlag2.id = phoneFlagImgStep2_2.id;
          phoneFlagImgStep2_2.replaceWith(clonedFlag2);
        }
      }
      if (phoneCodeHidden2) phoneCodeHidden2.value = phoneCode2Copy;

      // Устанавливаем телефон СРАЗУ, ДО инициализации phone_flag_selector
      phoneStep2_2.value = phoneNumber2;

      // Инициализируем phone_flag_selector для step2_2 ПОСЛЕ установки телефона
      if (typeof initPhoneFlagSelectorStep2 === 'function') {
        initPhoneFlagSelectorStep2('phoneFlagSelector_step2_2', 'phoneModal_step2_2', 'phoneFlagImg_step2_2', 'phoneCode_step2_2');
        syncStep2PhoneState('phone2', 'phoneCode2', 'phoneFlagImg2', 'phone_step2_2', 'phoneCode_step2_2', 'phoneFlagImg_step2_2', 'phoneFlagSelector_step2_2');
        // Восстанавливаем телефон после инициализации, если он был очищен
        setTimeout(() => {
          if (phoneStep2_2 && phoneStep2_2.value !== phoneNumber2 && phoneNumber2) {
            phoneStep2_2.value = phoneNumber2;
            phoneStep2_2.dispatchEvent(new Event('input', { bubbles: true }));
          }
          syncStep2PhoneState('phone2', 'phoneCode2', 'phoneFlagImg2', 'phone_step2_2', 'phoneCode_step2_2', 'phoneFlagImg_step2_2', 'phoneFlagSelector_step2_2');
        }, 50);
      }

      // Триггерим событие input для обновления UI
      phoneStep2_2.dispatchEvent(new Event('input', { bubbles: true }));
      phoneStep2_2.dispatchEvent(new Event('change', { bubbles: true }));

      // Переводим элементы step2 формы
      if (typeof window.translateStep2Form === 'function') {
        window.translateStep2Form('formStep2_2');
      }
    }

    // ОТПРАВЛЯЕМ ФОРМУ ШАГА 1 ПОСЛЕ того, как телефон уже скопирован в шаг 2
    const form = phone2.closest('form');
    if (form) {
      submitStep1Form(form, phone2, phoneCode2);
    }
  });
}

// ---------- Форма 3: Получить консультацию (определяем элементы сначала) ----------
const phone3 = document.getElementById('phone3');
const comment3 = document.getElementById('comment3');
const submitBtn3 = document.getElementById('submitBtn3');
const antibotLabel3 = document.getElementById('antibotLabel3');

let antibot3 = generateAntibot();
if (antibotLabel3) {
  updateAntibotLabel(antibotLabel3, antibot3);
}

let iti3 = null;

// ---------- Phone Flag Selector для формы 3 ----------
const phoneFlagSelector3 = document.getElementById("phoneFlagSelector3");
const phoneModal3 = document.getElementById("phoneModal3");
const phoneFlagImg3 = document.getElementById("phoneFlagImg3");
const phoneCode3 = document.getElementById("phoneCode3");
const phoneFlagArrow3 = document.getElementById("phoneFlagArrow3");

// Функция для генерации списка стран для phoneFlagSelector3
function generateCountryList3() {
  if (phoneModal3) {
    const phoneCountryOptionsContainer3 = phoneModal3.querySelector(".phone_country_options");
    const phoneModalHeader3 = phoneModal3.querySelector(".phone_modal_header");

    // Убеждаемся, что кнопка закрытия всегда есть в заголовке
    if (phoneModalHeader3) {
      let phoneCloseBtn3 = phoneModalHeader3.querySelector(".phone_close_btn");

      // Если кнопки нет в заголовке, ищем её в других местах
      if (!phoneCloseBtn3) {
        phoneCloseBtn3 = phoneModal3.querySelector(".phone_close_btn");
        if (phoneCloseBtn3) {
          // Перемещаем кнопку в заголовок
          phoneCloseBtn3.remove();
          phoneModalHeader3.appendChild(phoneCloseBtn3);
        } else {
          // Создаем кнопку закрытия, если её нет
          const closeBtn = document.createElement('button');
          closeBtn.className = 'phone_close_btn';
          closeBtn.innerHTML = '×';
          phoneModalHeader3.appendChild(closeBtn);
        }
      }

      // Убираем кнопку закрытия из контейнера опций, если она там есть
      if (phoneCountryOptionsContainer3) {
        const closeBtnInOptions = phoneCountryOptionsContainer3.querySelector(".phone_close_btn");
        if (closeBtnInOptions) {
          closeBtnInOptions.remove();
        }
      }
    }

    // Генерируем список стран, если нужно
    if (phoneCountryOptionsContainer3 && window.countryCodesData) {
      const existingOptions3 = phoneCountryOptionsContainer3.querySelectorAll(".phone_country_option");
      if (existingOptions3.length < 10) {
        phoneCountryOptionsContainer3.innerHTML = '';

        window.countryCodesData.forEach(country => {
          const option = document.createElement('div');
          option.className = 'phone_country_option';
          option.setAttribute('data-country', country.country);
          option.setAttribute('data-code', country.code);
          option.setAttribute('data-flag', 'emoji');
          option.setAttribute('data-placeholder', country.placeholder);
          option.innerHTML = `
            <span class="flag-emoji" aria-hidden="true">${window.getCountryFlagEmoji(country.country)}</span>
            <span>${country.code}</span>
          `;
          phoneCountryOptionsContainer3.appendChild(option);
        });

        // Обработчики событий уже добавлены через делегирование, не нужно добавлять снова
      }
    }
  }
}

// Вызываем генерацию списка стран после загрузки данных
if (window.countryCodesData && window.getCountryFlagEmoji) {
  generateCountryList3();
} else {
  // Ждем загрузки данных
  const checkCountryData3 = setInterval(() => {
    if (window.countryCodesData && window.getCountryFlagEmoji) {
      generateCountryList3();
      clearInterval(checkCountryData3);
    }
  }, 50);
  // Останавливаем проверку через 5 секунд
  setTimeout(() => clearInterval(checkCountryData3), 5000);
}

// Убеждаемся, что кнопка закрытия есть в заголовке для phoneModal3
if (phoneModal3 && typeof window.ensureCloseButtonInHeader === 'function') {
  window.ensureCloseButtonInHeader(phoneModal3);
}

if (phone3 && window.intlTelInput) {
  // Определяем регион при загрузке страницы
  let initialCountry = "ru";
  try {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : null;
    if (saved) {
      const r = JSON.parse(saved);
      if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') {
        initialCountry = "uz";
      }
    }
  } catch (e) {
    // Используем значение по умолчанию
  }

  iti3 = window.intlTelInput(phone3, {
    initialCountry: initialCountry,
    preferredCountries: ["ru", "uz"],
    nationalMode: false,
    formatOnDisplay: true,
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.6/build/js/utils.js",
  });

  // Сохраняем экземпляр iti в элементе для доступа извне
  phone3._iti = iti3;

  // Сохраняем правильный placeholder в data-атрибут
  const setCorrectPlaceholder3 = () => {
    if (iti3 && phone3) {
      try {
        const countryData = iti3.getSelectedCountryData();
        const countryCode = countryData ? countryData.dialCode : null;
        if (countryCode) {
          const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
          if (country && country.placeholder) {
            phone3.dataset.correctPlaceholder = country.placeholder;
            return country.placeholder;
          }
        }
      } catch (e) {
        // intl-tel-input еще не готов
      }
    }
    return null;
  };

  // Переопределяем setAttribute для перехвата всех изменений placeholder
  const originalSetAttribute3 = Element.prototype.setAttribute.bind(phone3);
  phone3.setAttribute = function (name, value) {
    if (name === 'placeholder') {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        Element.prototype.setAttribute.call(this, name, correctPlaceholder);
      } else {
        originalSetAttribute3.call(this, name, value);
      }
    } else {
      originalSetAttribute3.call(this, name, value);
    }
  };

  // Переопределяем прямое присваивание placeholder
  let correctPlaceholderValue3 = null;
  Object.defineProperty(phone3, 'placeholder', {
    get: function () {
      return correctPlaceholderValue3 || this.getAttribute('placeholder') || '';
    },
    set: function (value) {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        correctPlaceholderValue3 = correctPlaceholder;
        Element.prototype.setAttribute.call(this, 'placeholder', correctPlaceholder);
      } else {
        correctPlaceholderValue3 = value;
        Element.prototype.setAttribute.call(this, 'placeholder', value);
      }
    },
    configurable: true,
    enumerable: true
  });

  // Обновляем правильный placeholder после инициализации
  const updatePhone3Placeholder = () => {
    const placeholder = setCorrectPlaceholder3();
    if (placeholder) {
      phone3.placeholder = placeholder;
    }
  };

  setTimeout(() => updatePhone3Placeholder(), 300);
  setTimeout(() => updatePhone3Placeholder(), 800);
  setTimeout(() => updatePhone3Placeholder(), 1500);
  setTimeout(() => updatePhone3Placeholder(), 2500);
  setTimeout(() => updatePhone3Placeholder(), 4000);

  const placeholderCheckInterval3 = setInterval(() => {
    const correctPlaceholder = phone3.dataset.correctPlaceholder;
    if (correctPlaceholder) {
      const currentPlaceholder = phone3.getAttribute('placeholder');
      if (currentPlaceholder !== correctPlaceholder) {
        phone3.placeholder = correctPlaceholder;
      }
    }
  }, 300);

  setTimeout(() => {
    clearInterval(placeholderCheckInterval3);
  }, 15000);

  // Обновление кнопки при изменении телефона
  phone3.addEventListener('input', () => {
    updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
  });

  phone3.addEventListener('blur', () => {
    updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
  });

  // Обновление кнопки при изменении страны
  phone3.addEventListener('countrychange', () => {
    updatePhone3Placeholder();
    updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
  });
}

if (comment3 && submitBtn3) {
  comment3.addEventListener('input', () => {
    updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
  });

  comment3.addEventListener('blur', () => {
    updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
  });
}

// Инициализация кнопки при загрузке
if (phone3 && comment3 && submitBtn3) {
  // Ждем инициализации intlTelInput
  setTimeout(() => {
    if (iti3) {
      updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
    } else {
      // Если intlTelInput не загрузился, используем простую валидацию
      updateSubmitButton(phone3, comment3, submitBtn3, null, antibot3.answer);
    }
  }, 1000);

  // Также обновляем при изменении значения вручную
  phone3.addEventListener('change', () => {
    if (iti3) {
      updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
    } else {
      updateSubmitButton(phone3, comment3, submitBtn3, null, antibot3.answer);
    }
  });
}

// Обработчик отправки формы 3 - переход на вторую страницу
if (submitBtn3) {
  submitBtn3.addEventListener('click', (e) => {
    e.preventDefault();

    if (!validatePhone(phone3, iti3)) {
      alert('Пожалуйста, введите корректный номер телефона');
      return;
    }

    if (!checkAntibot(comment3.value, antibot3.answer)) {
      alert('Неверный ответ на вопрос антибота');
      // Генерируем новый антибот
      antibot3 = generateAntibot();
      if (antibotLabel3) {
        updateAntibotLabel(antibotLabel3, antibot3);
      }
      comment3.value = '';
      updateSubmitButton(phone3, comment3, submitBtn3, iti3, antibot3.answer);
      return;
    }

    // Переход на вторую страницу формы
    const formStep1_3 = document.querySelector('#block16 .form_hover') || document.querySelectorAll('.form_hover')[2];
    const formStep2_3 = document.getElementById('formStep2_3');
    const phoneStep2_3 = document.getElementById('phone_step2_3');

    if (formStep1_3 && formStep2_3 && phoneStep2_3) {
      // Получаем номер телефона без кода страны (начиная с 9)
      let phoneNumber = '';
      if (phone3 && phone3.value) {
        // Убираем все нецифровые символы
        const digits = phone3.value.replace(/\D/g, '');
        // Если номер начинается с 7 или 8, убираем первую цифру
        if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
          phoneNumber = digits.substring(1);
        } else if (digits.length > 0 && digits[0] === '9') {
          phoneNumber = digits;
        } else {
          phoneNumber = digits;
        }
      }

      // Копируем код страны и флаг ПЕРЕД установкой телефона
      const phoneCode3 = document.getElementById('phoneCode3')?.textContent || document.querySelectorAll('.phone-code')[2]?.textContent || '+7';
      const phoneFlagImg3 = document.getElementById('phoneFlagImg3') || document.querySelectorAll('.phoneFlagImg')[2];
      const phoneCodeStep2_3 = document.getElementById('phoneCode_step2_3');
      const phoneFlagImgStep2_3 = document.getElementById('phoneFlagImg_step2_3');
      const phoneCodeHidden3 = document.getElementById('parent_phone_code_3');

      if (phoneCodeStep2_3) phoneCodeStep2_3.textContent = phoneCode3;
      if (phoneFlagImgStep2_3 && phoneFlagImg3) {
        const clonedFlag3 = phoneFlagImg3.cloneNode(true);
        if (clonedFlag3) {
          clonedFlag3.id = phoneFlagImgStep2_3.id;
          phoneFlagImgStep2_3.replaceWith(clonedFlag3);
        }
      }
      if (phoneCodeHidden3) phoneCodeHidden3.value = phoneCode3;

      formStep1_3.style.display = 'none';
      formStep2_3.style.display = 'flex';

      // Переводим элементы step2 формы
      if (typeof window.translateStep2Form === 'function') {
        window.translateStep2Form('formStep2_3');
      }

      // Устанавливаем телефон СРАЗУ, ДО инициализации phone_flag_selector
      phoneStep2_3.value = phoneNumber;

      // Инициализируем phone_flag_selector для step2_3 ПОСЛЕ установки телефона
      if (typeof initPhoneFlagSelectorStep2 === 'function') {
        initPhoneFlagSelectorStep2('phoneFlagSelector_step2_3', 'phoneModal_step2_3', 'phoneFlagImg_step2_3', 'phoneCode_step2_3');
        syncStep2PhoneState('phone3', 'phoneCode3', 'phoneFlagImg3', 'phone_step2_3', 'phoneCode_step2_3', 'phoneFlagImg_step2_3', 'phoneFlagSelector_step2_3');
        // Восстанавливаем телефон после инициализации, если он был очищен
        setTimeout(() => {
          if (phoneStep2_3 && phoneStep2_3.value !== phoneNumber && phoneNumber) {
            phoneStep2_3.value = phoneNumber;
            phoneStep2_3.dispatchEvent(new Event('input', { bubbles: true }));
          }
          syncStep2PhoneState('phone3', 'phoneCode3', 'phoneFlagImg3', 'phone_step2_3', 'phoneCode_step2_3', 'phoneFlagImg_step2_3', 'phoneFlagSelector_step2_3');
        }, 50);
      }

      // Триггерим событие input для обновления UI
      phoneStep2_3.dispatchEvent(new Event('input', { bubbles: true }));
      phoneStep2_3.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ОТПРАВЛЯЕМ ФОРМУ ШАГА 1 ПОСЛЕ того, как телефон уже скопирован в шаг 2
    const form = document.getElementById('request_form_3') || phone3.closest('form');
    const phoneCode3 = document.getElementById('phoneCode3')?.textContent || document.querySelectorAll('.phone-code')[2]?.textContent || '+7';
    if (form && phone3) {
      // Явно указываем контейнер для формы 3
      const containerId = 'msgPlacerForm3Step1';
      submitStep1Form(form, phone3, phoneCode3, containerId);
    }
  });
}

// Инициализация валидации для четвертой формы (block18)
// middle-high: своя логика в secondary/script.js. primary-school: своя в primary/script.js (иначе два toggle на одном селекторе — дропдаун не открывается).
if (!document.body.classList.contains('middle-high-page') && !document.body.classList.contains('primary-school-page')) {
const phone4 = document.getElementById('phone4');
const comment4 = document.getElementById('comment4');
const submitBtn4 = document.getElementById('submitBtn4');
const antibotLabel4 = document.getElementById('antibotLabel4');

// ---------- Phone Flag Selector для Block18 ----------
const phoneFlagSelector4 = document.getElementById("phoneFlagSelector4");
const phoneModal4 = document.getElementById("phoneModal4");
const phoneFlagImg4 = document.getElementById("phoneFlagImg4");
const phoneCode4 = document.getElementById("phoneCode4");
const phoneFlagArrow4 = document.getElementById("phoneFlagArrow4");

if (phoneFlagImg4 && phoneCode4 && typeof window.getCountryByCode === 'function') {
  const currentCountry4 = window.getCountryByCode(phoneCode4.textContent.trim());
  if (currentCountry4 && currentCountry4.country) {
    const emoji4 = window.getCountryFlagEmoji(currentCountry4.country);
    if (phoneFlagImg4.tagName === 'SPAN') {
      phoneFlagImg4.classList.add('flag-emoji', 'phoneFlagImg');
      phoneFlagImg4.textContent = emoji4;
    } else if (phoneFlagImg4.parentNode) {
      const emojiSpan4 = document.createElement('span');
      emojiSpan4.className = 'flag-emoji phoneFlagImg';
      emojiSpan4.textContent = emoji4;
      emojiSpan4.id = 'phoneFlagImg4';
      phoneFlagImg4.parentNode.replaceChild(emojiSpan4, phoneFlagImg4);
    }
  }
}

// Функция для генерации списка стран для phoneFlagSelector4
function generateCountryList4() {
  if (phoneModal4) {
    const phoneCountryOptionsContainer4 = phoneModal4.querySelector(".phone_country_options");
    const phoneModalHeader4 = phoneModal4.querySelector(".phone_modal_header");

    // Убеждаемся, что кнопка закрытия всегда есть в заголовке
    if (phoneModalHeader4) {
      let phoneCloseBtn4 = phoneModalHeader4.querySelector(".phone_close_btn");

      // Если кнопки нет в заголовке, ищем её в других местах
      if (!phoneCloseBtn4) {
        phoneCloseBtn4 = phoneModal4.querySelector(".phone_close_btn");
        if (phoneCloseBtn4) {
          // Перемещаем кнопку в заголовок
          phoneCloseBtn4.remove();
          phoneModalHeader4.appendChild(phoneCloseBtn4);
        } else {
          // Создаем кнопку закрытия, если её нет
          const closeBtn = document.createElement('button');
          closeBtn.className = 'phone_close_btn';
          closeBtn.innerHTML = '×';
          phoneModalHeader4.appendChild(closeBtn);
        }
      }

      // Убираем кнопку закрытия из контейнера опций, если она там есть
      if (phoneCountryOptionsContainer4) {
        const closeBtnInOptions = phoneCountryOptionsContainer4.querySelector(".phone_close_btn");
        if (closeBtnInOptions) {
          closeBtnInOptions.remove();
        }
      }
    }

    // Генерируем список стран, если нужно
    if (phoneCountryOptionsContainer4 && window.countryCodesData) {
      const existingOptions4 = phoneCountryOptionsContainer4.querySelectorAll(".phone_country_option");
      if (existingOptions4.length < 10) {
        phoneCountryOptionsContainer4.innerHTML = '';

        window.countryCodesData.forEach(country => {
          const option = document.createElement('div');
          option.className = 'phone_country_option';
          option.setAttribute('data-country', country.country);
          option.setAttribute('data-code', country.code);
          option.setAttribute('data-flag', 'emoji');
          option.setAttribute('data-placeholder', country.placeholder);
          option.innerHTML = `
            <span class="flag-emoji" aria-hidden="true">${window.getCountryFlagEmoji(country.country)}</span>
            <span>${country.code}</span>
          `;
          phoneCountryOptionsContainer4.appendChild(option);
        });

        // Обработчики событий уже добавлены через делегирование, не нужно добавлять снова
      }
    }
  }
}

// Вызываем генерацию списка стран после загрузки данных
if (window.countryCodesData && window.getCountryFlagEmoji) {
  generateCountryList4();
} else {
  // Ждем загрузки данных
  const checkCountryData4 = setInterval(() => {
    if (window.countryCodesData && window.getCountryFlagEmoji) {
      generateCountryList4();
      clearInterval(checkCountryData4);
    }
  }, 50);
  // Останавливаем проверку через 5 секунд
  setTimeout(() => clearInterval(checkCountryData4), 5000);
}

// Убеждаемся, что кнопка закрытия есть в заголовке для phoneModal4
if (phoneModal4 && typeof window.ensureCloseButtonInHeader === 'function') {
  window.ensureCloseButtonInHeader(phoneModal4);
}

const phoneCountryOptions4 = phoneModal4 ? phoneModal4.querySelectorAll(".phone_country_option") : [];
const phoneCloseBtn4 = phoneModal4 ? phoneModal4.querySelector(".phone_close_btn") : null;

function openPhoneModal4() {
  if (phoneModal4) phoneModal4.classList.add("open");
  if (phoneFlagSelector4) phoneFlagSelector4.classList.add("active");
}

function closePhoneModal4() {
  if (phoneModal4) phoneModal4.classList.remove("open");
  if (phoneFlagSelector4) phoneFlagSelector4.classList.remove("active");
}

if (phoneFlagSelector4 && phoneModal4) {
  phoneFlagSelector4.addEventListener("click", (e) => {
    // Проверяем, что клик не на phone_modal_wrapper или его дочерних элементах
    const phoneModalWrapper = phoneFlagSelector4.querySelector('.phone_modal_wrapper');
    if (phoneModalWrapper && (phoneModalWrapper.contains(e.target) || e.target === phoneModalWrapper)) {
      return;
    }
    // Проверяем, что клик не на comment или его родительских элементах
    const comment4 = document.getElementById('comment4');
    if (comment4 && (comment4.contains(e.target) || e.target === comment4 || e.target.closest('.input_column_right'))) {
      return;
    }
    e.stopPropagation();
    phoneModal4.classList.toggle("open");
    phoneFlagSelector4.classList.toggle("active");
  });

  // Используем делегирование событий для работы с динамически созданными элементами
  const phoneCountryOptionsContainer4 = phoneModal4.querySelector(".phone_country_options");
  if (phoneCountryOptionsContainer4) {
    phoneCountryOptionsContainer4.addEventListener("click", (e) => {
      const option = e.target.closest(".phone_country_option");
      if (!option) return;

      e.stopPropagation();
      // Проверяем, что клик не на кнопке закрытия
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        return;
      }

      const country = option.dataset.country;
      const code = option.dataset.code;
      const placeholder = option.dataset.placeholder || '';

      // Всегда берём актуальный узел флага: после replaceChild старый phoneFlagImg4 отвязан от DOM
      const flagEl = document.getElementById('phoneFlagImg4');
      if (flagEl) {
        const emojiFlag = window.getCountryFlagEmoji(country);
        if (flagEl.tagName === 'SPAN') {
          flagEl.classList.add('flag-emoji', 'phoneFlagImg');
          flagEl.textContent = emojiFlag;
        } else {
          const parent = flagEl.parentNode;
          if (parent) {
            const emojiSpan = document.createElement('span');
            emojiSpan.className = 'flag-emoji phoneFlagImg';
            emojiSpan.textContent = emojiFlag;
            emojiSpan.id = 'phoneFlagImg4';
            parent.replaceChild(emojiSpan, flagEl);
          }
        }
      }
      if (phoneCode4) phoneCode4.textContent = code;
      // Очищаем поле телефона при смене кода страны и обновляем placeholder
      const phoneInput4 = phoneCode4.closest('.phone_wrapper')?.querySelector('input[type="tel"]');
      if (phoneInput4) {
        phoneInput4.value = '';
        if (placeholder) {
          phoneInput4.placeholder = placeholder;
        }
        phoneInput4.dataset.countryCode = code;
      }

      const curCountryEl = document.getElementById('curCountry');
      const currentRegion = curCountryEl ? curCountryEl.textContent.trim() : 'Россия';
      const phoneWrapper4 = phoneCode4 ? phoneCode4.closest('.phone_wrapper') : null;
      updatePhoneInputsLimits(currentRegion, phoneWrapper4);

      // Обновляем intlTelInput, если он инициализирован
      setTimeout(() => {
        if (iti4 && phone4) {
          try {
            iti4.setCountry(country);
          } catch (e) {
          }
        }

        // Обновляем кнопку после изменения страны
        if (phone4 && comment4 && submitBtn4) {
          updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
        }
      }, 100);

      closePhoneModal4();
    });
  }

  // Используем делегирование событий для кнопки закрытия (работает с динамически созданными кнопками)
  const phoneModalHeader4 = phoneModal4 ? phoneModal4.querySelector(".phone_modal_header") : null;
  if (phoneModalHeader4) {
    phoneModalHeader4.addEventListener("click", (e) => {
      if (e.target.classList.contains("phone_close_btn") || e.target.closest(".phone_close_btn")) {
        e.stopPropagation();
        e.preventDefault();
        closePhoneModal4();
      }
    });
  }

  // Также привязываем обработчик напрямую к существующей кнопке
  if (phoneCloseBtn4) {
    phoneCloseBtn4.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();
      closePhoneModal4();
    });
  }

  // Добавляем валидацию для поля телефона
  const phoneInput4 = phoneCode4?.closest('.phone_wrapper')?.querySelector('input[type="tel"]');
  if (phoneInput4 && typeof window.validatePhoneNumber === 'function') {
    phoneInput4.addEventListener('blur', function () {
      const countryCode = this.dataset.countryCode || phoneCode4?.textContent;
      if (countryCode && this.value.trim()) {
        const validation = window.validatePhoneNumber(this.value, countryCode);
        if (!validation.valid) {
          this.setCustomValidity(validation.message);
          this.reportValidity();
        } else {
          this.setCustomValidity('');
        }
      }
    });

    phoneInput4.addEventListener('input', function () {
      if (this.validity.customError) {
        this.setCustomValidity('');
      }
    });
  }

  document.addEventListener("click", (e) => {
    if (!phoneFlagSelector4.contains(e.target) && !phoneModal4.contains(e.target)) {
      closePhoneModal4();
    }
  });
}

let antibot4 = generateAntibot();
if (antibotLabel4) {
  updateAntibotLabel(antibotLabel4, antibot4);
}

let iti4 = null;
if (phone4 && window.intlTelInput) {
  // Определяем регион при загрузке страницы
  let initialCountry = "ru";
  try {
    const saved = (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined')
      ? window.getCookie(window.COOKIE_NAME)
      : null;
    if (saved) {
      const r = JSON.parse(saved);
      if (r.name === 'Узбекистан' || r.name === 'Uzbekistan') {
        initialCountry = "uz";
      }
    }
  } catch (e) {
    // Используем значение по умолчанию
  }

  iti4 = window.intlTelInput(phone4, {
    initialCountry: initialCountry,
    preferredCountries: ["ru", "uz"],
    nationalMode: false,
    separateDialCode: false,
    utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@21.2.6/build/js/utils.js"
  });

  // Сохраняем экземпляр iti в элементе для доступа извне
  phone4._iti = iti4;

  // Сохраняем правильный placeholder в data-атрибут
  const setCorrectPlaceholder4 = () => {
    if (iti4 && phone4) {
      try {
        const countryData = iti4.getSelectedCountryData();
        const countryCode = countryData ? countryData.dialCode : null;
        if (countryCode) {
          const country = window.getCountryByCode && window.getCountryByCode('+' + countryCode);
          if (country && country.placeholder) {
            phone4.dataset.correctPlaceholder = country.placeholder;
            return country.placeholder;
          }
        }
      } catch (e) {
        // intl-tel-input еще не готов
      }
    }
    return null;
  };

  // Переопределяем setAttribute для перехвата всех изменений placeholder
  const originalSetAttribute4 = Element.prototype.setAttribute.bind(phone4);
  phone4.setAttribute = function (name, value) {
    if (name === 'placeholder') {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        Element.prototype.setAttribute.call(this, name, correctPlaceholder);
      } else {
        originalSetAttribute4.call(this, name, value);
      }
    } else {
      originalSetAttribute4.call(this, name, value);
    }
  };

  // Переопределяем прямое присваивание placeholder
  let correctPlaceholderValue4 = null;
  Object.defineProperty(phone4, 'placeholder', {
    get: function () {
      return correctPlaceholderValue4 || this.getAttribute('placeholder') || '';
    },
    set: function (value) {
      const correctPlaceholder = this.dataset.correctPlaceholder;
      if (correctPlaceholder) {
        correctPlaceholderValue4 = correctPlaceholder;
        Element.prototype.setAttribute.call(this, 'placeholder', correctPlaceholder);
      } else {
        correctPlaceholderValue4 = value;
        Element.prototype.setAttribute.call(this, 'placeholder', value);
      }
    },
    configurable: true,
    enumerable: true
  });

  // Обновляем правильный placeholder после инициализации
  const updatePhone4Placeholder = () => {
    const placeholder = setCorrectPlaceholder4();
    if (placeholder) {
      phone4.placeholder = placeholder;
    }
  };

  setTimeout(() => updatePhone4Placeholder(), 300);
  setTimeout(() => updatePhone4Placeholder(), 800);
  setTimeout(() => updatePhone4Placeholder(), 1500);
  setTimeout(() => updatePhone4Placeholder(), 2500);
  setTimeout(() => updatePhone4Placeholder(), 4000);

  const placeholderCheckInterval4 = setInterval(() => {
    const correctPlaceholder = phone4.dataset.correctPlaceholder;
    if (correctPlaceholder) {
      const currentPlaceholder = phone4.getAttribute('placeholder');
      if (currentPlaceholder !== correctPlaceholder) {
        phone4.placeholder = correctPlaceholder;
      }
    }
  }, 300);

  setTimeout(() => {
    clearInterval(placeholderCheckInterval4);
  }, 15000);

  phone4.addEventListener('input', () => {
    updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
  });

  phone4.addEventListener('blur', () => {
    updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
  });

  phone4.addEventListener('countrychange', () => {
    updatePhone4Placeholder();
    updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
  });
}

if (comment4 && submitBtn4) {
  comment4.addEventListener('input', () => {
    updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
  });

  comment4.addEventListener('blur', () => {
    updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
  });
}

if (phone4 && comment4 && submitBtn4) {
  setTimeout(() => {
    if (iti4) {
      updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
    } else {
      updateSubmitButton(phone4, comment4, submitBtn4, null, antibot4.answer);
    }
  }, 1000);

  phone4.addEventListener('change', () => {
    if (iti4) {
      updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
    } else {
      updateSubmitButton(phone4, comment4, submitBtn4, null, antibot4.answer);
    }
  });
}

if (submitBtn4) {
  submitBtn4.addEventListener('click', (e) => {
    e.preventDefault();

    if (!validatePhone(phone4, iti4)) {
      alert('Пожалуйста, введите корректный номер телефона');
      return;
    }

    if (!checkAntibot(comment4.value, antibot4.answer)) {
      alert('Неверный ответ на вопрос антибота');
      antibot4 = generateAntibot();
      if (antibotLabel4) {
        updateAntibotLabel(antibotLabel4, antibot4);
      }
      comment4.value = '';
      updateSubmitButton(phone4, comment4, submitBtn4, iti4, antibot4.answer);
      return;
    }

    const formStep1_4 = document.querySelector('.block18 .form_hover');
    const formStep2_4 = document.getElementById('formStep2_4');
    const phoneStep2_4 = document.getElementById('phone_step2_4');

    if (formStep1_4 && formStep2_4 && phoneStep2_4) {
      let phoneNumber = '';
      if (phone4 && phone4.value) {
        const digits = phone4.value.replace(/\D/g, '');
        if (digits.length > 0 && (digits[0] === '7' || digits[0] === '8')) {
          phoneNumber = digits.substring(1);
        } else {
          phoneNumber = digits;
        }
      }

      // Копируем код страны и флаг ПЕРЕД установкой телефона
      const phoneCode4 = document.getElementById('phoneCode4')?.textContent || '+7';
      const phoneFlagImg4 = document.getElementById('phoneFlagImg4');
      const phoneCodeStep2_4 = document.getElementById('phoneCode_step2_4');
      const phoneFlagImgStep2_4 = document.getElementById('phoneFlagImg_step2_4');
      const phoneCodeHidden4 = document.getElementById('parent_phone_code_4');

      if (phoneCodeStep2_4) phoneCodeStep2_4.textContent = phoneCode4;
      if (phoneFlagImgStep2_4 && phoneFlagImg4) {
        const clonedFlag4 = phoneFlagImg4.cloneNode(true);
        if (clonedFlag4) {
          clonedFlag4.id = phoneFlagImgStep2_4.id;
          phoneFlagImgStep2_4.replaceWith(clonedFlag4);
        }
      }
      if (phoneCodeHidden4) phoneCodeHidden4.value = phoneCode4;

      formStep1_4.style.display = 'none';
      formStep2_4.style.display = 'flex';

      // Обновляем картинку кампуса по текущему выбору (важно при UZ — по умолчанию Ташкент)
      const campus4 = document.getElementById('campus_4');
      if (campus4 && typeof updateCampusImage === 'function') {
        const campusImage4 = document.getElementById('campusImage_4');
        const campusCaption4 = document.getElementById('campusCaption_4');
        const campusImage4Desktop = document.getElementById('campusImage_4_desktop');
        const campusCaption4Desktop = document.getElementById('campusCaption_4_desktop');
        if (campusImage4) {
          updateCampusImage(campus4, campusImage4, campusCaption4, campusImage4Desktop, campusCaption4Desktop);
        }
      }

      // Переводим элементы step2 формы
      if (typeof window.translateStep2Form === 'function') {
        window.translateStep2Form('formStep2_4');
      }

      // Устанавливаем телефон СРАЗУ, ДО инициализации phone_flag_selector
      phoneStep2_4.value = phoneNumber;

      // Инициализируем phone_flag_selector для step2_4 ПОСЛЕ установки телефона
      if (typeof initPhoneFlagSelectorStep2 === 'function') {
        initPhoneFlagSelectorStep2('phoneFlagSelector_step2_4', 'phoneModal_step2_4', 'phoneFlagImg_step2_4', 'phoneCode_step2_4');
        syncStep2PhoneState('phone4', 'phoneCode4', 'phoneFlagImg4', 'phone_step2_4', 'phoneCode_step2_4', 'phoneFlagImg_step2_4', 'phoneFlagSelector_step2_4');
        // Восстанавливаем телефон после инициализации, если он был очищен
        setTimeout(() => {
          if (phoneStep2_4 && phoneStep2_4.value !== phoneNumber && phoneNumber) {
            phoneStep2_4.value = phoneNumber;
            phoneStep2_4.dispatchEvent(new Event('input', { bubbles: true }));
          }
          syncStep2PhoneState('phone4', 'phoneCode4', 'phoneFlagImg4', 'phone_step2_4', 'phoneCode_step2_4', 'phoneFlagImg_step2_4', 'phoneFlagSelector_step2_4');
        }, 50);
      }

      // Триггерим событие input для обновления UI
      phoneStep2_4.dispatchEvent(new Event('input', { bubbles: true }));
      phoneStep2_4.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ОТПРАВЛЯЕМ ФОРМУ ШАГА 1 ПОСЛЕ того, как телефон уже скопирован в шаг 2
    const form = document.getElementById('request_form_4') || phone4.closest('form');
    const phoneCode4 = document.getElementById('phoneCode4')?.textContent || '+7';
    if (form && phone4) {
      // Явно указываем контейнер для формы 4
      const containerId = 'msgPlacerForm4Step1';
      submitStep1Form(form, phone4, phoneCode4, containerId);
    }
  });
}
} // end guard: form 4 не дублируем на middle-high-page и primary-school-page

// ============================================
// ВАЛИДАЦИЯ И ОБРАБОТКА ВТОРОЙ СТРАНИЦЫ ФОРМЫ
// ============================================

// Функция валидации email
// Функции validateEmail и validateBirthDate вынесены в utils/validation.js

// Маппинг кампусов к изображениям и подписям
// Используем данные из CMS, если они доступны, иначе fallback на статичные данные
let campusImages = {
  skolkovo: landingAssetPath('/landing_2025/src/img/Campus_1.webp'),
  moscow: landingAssetPath('/landing_2025/src/img/Campus_2.webp'),
  gorki: landingAssetPath('/landing_2025/src/img/Campus_3.webp'),
  spb: landingAssetPath('/landing_2025/src/img/Campus_4.webp'),
  tashkent: landingAssetPath('/landing_2025/src/img/Campus_5.webp'),
  '5': landingAssetPath('/landing_2025/src/img/Campus_1.webp'),
  '2': landingAssetPath('/landing_2025/src/img/Campus_2.webp'),
  '3': landingAssetPath('/landing_2025/src/img/Campus_3.webp'),
  '1': landingAssetPath('/landing_2025/src/img/Campus_4.webp'),
  '4': landingAssetPath('/landing_2025/src/img/Campus_5.webp'),
};

let campusCaptions = {
  skolkovo: 'Кампус Сколково',
  moscow: 'Кампус Москва',
  gorki: 'Кампус Горки',
  spb: 'Кампус Санкт-Петербург',
  tashkent: 'Кампус Ташкент',
  '5': 'Кампус Сколково',
  '2': 'Кампус Москва',
  '3': 'Кампус Горки',
  '1': 'Кампус Санкт-Петербург',
  '4': 'Кампус Ташкент',
};

// Убираем префикс "Кампус "/"Campus " из названия из БД (там уже может быть "Кампус Москва")
const stripCampusPrefixForCMS = (name) => (name || '').replace(/<br\s*\/?>/gi, ' ').trim().replace(/^(Кампус |Campus )/i, '');

// Функция для обновления данных кампусов из CMS
function updateCampusDataFromCMS() {
  if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
    window.campusesFromCMS.forEach(function (campus) {
      // Маппинг по slug
      if (campus.slug) {
        campusImages[campus.slug] = campus.picture;
        const lang = localStorage.getItem('siteLanguage') || 'ru';
        const campusName = lang === 'en' ? campus.name_en : campus.name_ru;
        const cleanName = stripCampusPrefixForCMS(campusName);
        campusCaptions[campus.slug] = lang === 'en' ? `Campus ${cleanName}` : `Кампус ${cleanName}`;
      }
      // Маппинг по ID
      if (campus.id) {
        campusImages[campus.id.toString()] = campus.picture;
        const lang = localStorage.getItem('siteLanguage') || 'ru';
        const campusName = lang === 'en' ? campus.name_en : campus.name_ru;
        const cleanName = stripCampusPrefixForCMS(campusName);
        campusCaptions[campus.id.toString()] = lang === 'en' ? `Campus ${cleanName}` : `Кампус ${cleanName}`;
      }
    });
  }
}

// Обновляем данные из CMS при загрузке (после того, как window.campusesFromCMS будет доступен)
// Используем немедленное выполнение, если данные уже доступны, иначе ждем DOMContentLoaded
if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
  // Данные уже доступны, обновляем сразу
  updateCampusDataFromCMS();
} else {
  // Данные еще не загружены, ждем DOMContentLoaded
  function scheduleUpdateCampusDataFromCMS() {
    // Небольшая задержка, чтобы убедиться, что window.campusesFromCMS уже загружен
    setTimeout(updateCampusDataFromCMS, 100);
  }
  if (document.readyState === "loading") {
    document.addEventListener('DOMContentLoaded', scheduleUpdateCampusDataFromCMS);
  } else {
    scheduleUpdateCampusDataFromCMS();
  }
}

// Обновляем данные при изменении языка
window.addEventListener('languageChanged', function () {
  updateCampusDataFromCMS();
});

// Функция обновления изображения кампуса
function updateCampusImage(campusSelect, imageElement, captionElement, desktopImageElement, desktopCaptionElement) {
  if (!campusSelect || !imageElement) return;

  const setImage = () => {
    const campus = '' + (campusSelect.value || 'skolkovo');

    // Обновляем изображение из данных CMS или fallback
    let imageSrc = campusImages[campus];

    // Если есть данные из CMS, используем их
    if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
      const campusFromCMS = window.campusesFromCMS.find(c => c.slug === campus || c.id.toString() === campus);
      if (campusFromCMS && campusFromCMS.picture) {
        imageSrc = campusFromCMS.picture;
      }
    }

    if (imageSrc) {
      // Обновляем мобильное изображение
      imageElement.src = imageSrc;
      // Обновляем десктопное изображение, если оно есть
      if (desktopImageElement) {
        desktopImageElement.src = imageSrc;
      }
    }

    // Обновляем подписи с учетом языка
    const lang = localStorage.getItem('siteLanguage') || 'ru';
    const t = typeof translations !== 'undefined' && translations[lang] ? translations[lang] : null;
    let captionText = campusCaptions[campus]; // По умолчанию русский

    // Убираем префикс "Кампус "/"Campus " из названия, чтобы не получалось "Кампус Кампус ..."
    const stripCampusPrefix = (name) => (name || '').replace(/<br\s*\/?>/gi, ' ').trim().replace(/^(Кампус |Campus )/i, '');
    // Если есть данные из CMS, используем их для подписи
    if (typeof window.campusesFromCMS !== 'undefined' && Array.isArray(window.campusesFromCMS)) {
      const campusFromCMS = window.campusesFromCMS.find(c => c.slug === campus || c.id.toString() === campus);
      if (campusFromCMS) {
        const campusName = stripCampusPrefix(lang === 'en' ? campusFromCMS.name_en : campusFromCMS.name_ru);
        captionText = lang === 'en' ? `Campus ${campusName}` : `Кампус ${campusName}`;
      }
    } else if (t && t[`campus_name_${campus}`]) {
      const campusName = stripCampusPrefix(t[`campus_name_${campus}`]);
      captionText = lang === 'en' ? `Campus ${campusName}` : `Кампус ${campusName}`;
    }

    // Обновляем мобильную подпись
    if (captionElement) {
      captionElement.textContent = captionText;
    }
    // Обновляем десктопную подпись, если она есть
    if (desktopCaptionElement) {
      desktopCaptionElement.textContent = captionText;
    }
  };

  campusSelect.addEventListener('change', setImage);
  setImage();

  // Обновляем при изменении языка
  window.addEventListener('languageChanged', setImage);
}

// Функция для управления состоянием отправки формы
const setFormSubmitting = (form, isSubmitting) => {
  const submitButton = form.querySelector('.form_step2_submit');
  const loader = form.querySelector('.form_step2_loader');
  if (submitButton) submitButton.disabled = isSubmitting;
  if (loader) loader.style.display = isSubmitting ? 'block' : 'none';
};

// Делаем функцию доступной глобально
window.setFormSubmitting = setFormSubmitting;

// Функция синхронизации кода телефона
const syncPhoneCode = (form) => {
  const phoneInputs = form.querySelectorAll('input[type="tel"][id^="phone_step2_"]');
  phoneInputs.forEach((input) => {
    const wrapper = input.closest('.phone_wrapper');
    const codeEl = wrapper ? wrapper.querySelector('.phone-code') : null;
    const code = codeEl ? codeEl.textContent.trim() : '';
    const hidden = wrapper ? wrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
    if (hidden) hidden.value = code;
  });
};

// Функция отправки формы
const submitLandingForm = (trigger) => {
  // Пытаемся найти форму разными способами
  let form = trigger.closest('form');

  // Если не нашли через closest, пытаемся найти по ID формы
  if (!form) {
    // Определяем ID формы по ID кнопки или контексту
    const triggerId = trigger.id || '';
    if (triggerId.includes('submitStep2_3')) {
      form = document.getElementById('request_form_3');
    } else if (triggerId.includes('submitStep2_4')) {
      form = document.getElementById('request_form_4');
    } else if (triggerId.includes('submitStep2_1')) {
      form = document.getElementById('request_form_1');
    } else if (triggerId.includes('submitStep2_2')) {
      form = document.getElementById('request_form_2');
    } else if (triggerId.includes('submitStep2_trial_day')) {
      form = document.getElementById('request_form_trial_day');
    }
  }

  if (!form) {
    alert('ОШИБКА: форма не найдена!');
    console.error('Не удалось найти форму для триггера:', trigger);
    return;
  }

  syncPhoneCode(form);
  window.callTouchHandlers?.handleForm(form); // CallTouch (see layouts/_calltouch.html)

  // Проверяем, что форма настроена на AJAX (remote: true)
  const isRemote = form.hasAttribute('data-remote') || form.getAttribute('data-remote') === 'true';


  if (isRemote) {
    // Отправляем через AJAX вручную
    const formData = new FormData(form);
    const url = form.action || form.getAttribute('action');
    const method = form.method || 'POST';

    window.utmHandlers?.fillFormUtm(formData, 'request'); // append UTM (see javascripts/utils/utm-tags-handlers.js)


    // Выводим данные формы для отладки
    for (let [key, value] of formData.entries()) {
      if (key !== 'authenticity_token') {
      }
    }

    // Получаем CSRF токен
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
      form.querySelector('input[name="authenticity_token"]')?.value;

    fetch(url, {
      method: method,
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/javascript'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          return response.text().then(text => {
            throw new Error('Ошибка отправки формы: ' + response.status);
          });
        }
      })
      .then(text => {
        // Выполняем JavaScript ответ от сервера безопасным способом
        const script = document.createElement('script');
        script.textContent = text;
        document.head.appendChild(script);
        document.head.removeChild(script);
      })
      .catch(error => {
        alert('Ошибка отправки формы: ' + error.message);
        setFormSubmitting(form, false);
      });
  } else {
    // Обычная отправка формы
    if (form.requestSubmit) {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }
};

// Делаем функции доступными глобально
window.syncPhoneCode = syncPhoneCode;
window.submitLandingForm = submitLandingForm;

// Инициализация валидации для первой формы (step 2)
// Ожидаем загрузки DOM
const initForm1 = () => {
  const email1 = document.getElementById('email_1');
  const birthDate1 = document.getElementById('birth_date_1');
  const campus1 = document.getElementById('campus_1');
  const campusImage1 = document.getElementById('campusImage_1');
  const campusCaption1 = document.getElementById('campusCaption_1');
  const campusImage1Desktop = document.getElementById('campusImage_1_desktop');
  const campusCaption1Desktop = document.getElementById('campusCaption_1_desktop');
  const submitStep2_1 = document.getElementById('submitStep2_1');


  if (email1) {
    email1.addEventListener('input', () => {
      if (email1.value && validateEmail(email1.value)) {
        email1.classList.remove('error');
      }
    });
    email1.addEventListener('blur', () => {
      if (email1.value && !validateEmail(email1.value)) {
        email1.classList.add('error');
      } else {
        email1.classList.remove('error');
      }
    });
  }

  if (birthDate1) {
    // Маска для даты рождения
    birthDate1.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      if (value.length >= 5) {
        value = value.slice(0, 5) + '.' + value.slice(5, 9);
      }
      e.target.value = value;
    });

    birthDate1.addEventListener('input', () => {
      if (birthDate1.value && validateBirthDate(birthDate1.value)) {
        birthDate1.classList.remove('error');
      }
    });
    birthDate1.addEventListener('blur', () => {
      if (birthDate1.value && !validateBirthDate(birthDate1.value)) {
        birthDate1.classList.add('error');
      } else {
        birthDate1.classList.remove('error');
      }
    });
  }

  if (campus1 && campusImage1) {
    updateCampusImage(campus1, campusImage1, campusCaption1, campusImage1Desktop, campusCaption1Desktop);
  }

  if (submitStep2_1) {
    submitStep2_1.addEventListener('click', (e) => {
      e.preventDefault();

      // Валидация всех полей
      let isValid = true;
      const missingFields = [];

      // Валидация телефона
      const phoneStep2_1 = document.getElementById('phone_step2_1');
      if (phoneStep2_1) {
        const phoneWrapper = phoneStep2_1.closest('.phone_wrapper');
        const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
        const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
        const phoneCodeHidden = phoneWrapper ? phoneWrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
        if (phoneCodeHidden) phoneCodeHidden.value = code;

        // Используем универсальную валидацию из countryCodes.js
        if (window.validatePhoneNumber && phoneStep2_1.value.trim()) {
          const validation = window.validatePhoneNumber(phoneStep2_1.value, code);
          if (!validation.valid) {
            phoneStep2_1.classList.add('error');
            isValid = false;
            missingFields.push('Телефон');
          } else {
            phoneStep2_1.classList.remove('error');
          }
        } else if (!phoneStep2_1.value.trim()) {
          phoneStep2_1.classList.add('error');
          isValid = false;
          missingFields.push('Телефон');
        } else {
          phoneStep2_1.classList.remove('error');
        }
      }

      if (!email1.value || !validateEmail(email1.value)) {
        email1.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        email1.classList.remove('error');
      }

      // birthDate1 и childName1 - необязательные поля, не проверяем

      const parentName1 = document.getElementById('parent_name_1');
      const childName1 = document.getElementById('child_name_1');

      if (!parentName1.value) {
        parentName1.classList.add('error');
        isValid = false;
        missingFields.push('Имя и фамилия родителя');
      } else {
        parentName1.classList.remove('error');
      }

      // childName1 - необязательное поле, не проверяем

      if (!campus1.value) {
        campus1.classList.add('error');
        isValid = false;
        missingFields.push('Кампус');
      } else {
        campus1.classList.remove('error');
      }

      if (!isValid) {
        const message = 'Пожалуйста, заполните обязательные поля: ' + missingFields.join(', ');
        alert(message);
        return;
      }

      // Здесь можно добавить отправку данных на сервер
      const form = submitStep2_1.closest('form');
      if (!form) {
        return;
      }
      setFormSubmitting(form, true);
      submitLandingForm(e.currentTarget);
      // alert('Заявка успешно отправлена!');
    });
  }
};

// Инициализация валидации для второй формы (step 2)
const initForm2 = () => {

  const email2 = document.getElementById('email_2');
  const birthDate2 = document.getElementById('birth_date_2');
  const campus2 = document.getElementById('campus_2');
  const campusImage2 = document.getElementById('campusImage_2');
  const campusCaption2 = document.getElementById('campusCaption_2');
  const campusImage2Desktop = document.getElementById('campusImage_2_desktop');
  const campusCaption2Desktop = document.getElementById('campusCaption_2_desktop');
  const submitStep2_2 = document.getElementById('submitStep2_2');


  if (email2) {
    email2.addEventListener('input', () => {
      if (email2.value && validateEmail(email2.value)) {
        email2.classList.remove('error');
      }
    });
    email2.addEventListener('blur', () => {
      if (email2.value && !validateEmail(email2.value)) {
        email2.classList.add('error');
      } else {
        email2.classList.remove('error');
      }
    });
  }

  if (birthDate2) {
    // Маска для даты рождения
    birthDate2.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      if (value.length >= 5) {
        value = value.slice(0, 5) + '.' + value.slice(5, 9);
      }
      e.target.value = value;
    });

    birthDate2.addEventListener('input', () => {
      if (birthDate2.value && validateBirthDate(birthDate2.value)) {
        birthDate2.classList.remove('error');
      }
    });
    birthDate2.addEventListener('blur', () => {
      if (birthDate2.value && !validateBirthDate(birthDate2.value)) {
        birthDate2.classList.add('error');
      } else {
        birthDate2.classList.remove('error');
      }
    });
  }

  if (campus2 && campusImage2) {
    updateCampusImage(campus2, campusImage2, campusCaption2, campusImage2Desktop, campusCaption2Desktop);
  }

  // Добавляем обработчики для удаления error при корректном вводе
  const phoneStep2_2 = document.getElementById('phone_step2_2');
  if (phoneStep2_2) {
    phoneStep2_2.addEventListener('input', () => {
      const phoneWrapper = phoneStep2_2.closest('.phone_wrapper');
      const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
      const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
      // Используем универсальную валидацию из countryCodes.js
      if (window.validatePhoneNumber && phoneStep2_2.value.trim()) {
        const validation = window.validatePhoneNumber(phoneStep2_2.value, code);
        if (validation.valid) {
          phoneStep2_2.classList.remove('error');
        }
      }
    });
  }

  const parentName2 = document.getElementById('parent_name_2');
  if (parentName2) {
    parentName2.addEventListener('input', () => {
      if (parentName2.value) {
        parentName2.classList.remove('error');
      }
    });
  }

  const childName2 = document.getElementById('child_name_2');
  if (childName2) {
    childName2.addEventListener('input', () => {
      if (childName2.value) {
        childName2.classList.remove('error');
      }
    });
  }

  if (campus2) {
    campus2.addEventListener('change', () => {
      if (campus2.value) {
        campus2.classList.remove('error');
      }
    });
  }

  if (submitStep2_2) {
    submitStep2_2.addEventListener('click', (e) => {
      e.preventDefault();

      // Валидация всех полей
      let isValid = true;
      const missingFields = [];

      // Валидация телефона
      const phoneStep2_2 = document.getElementById('phone_step2_2');
      if (phoneStep2_2) {
        const phoneWrapper = phoneStep2_2.closest('.phone_wrapper');
        const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
        const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
        const phoneCodeHidden = phoneWrapper ? phoneWrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
        if (phoneCodeHidden) phoneCodeHidden.value = code;

        // Используем универсальную валидацию из countryCodes.js
        if (window.validatePhoneNumber && phoneStep2_2.value.trim()) {
          const validation = window.validatePhoneNumber(phoneStep2_2.value, code);
          if (!validation.valid) {
            phoneStep2_2.classList.add('error');
            isValid = false;
            missingFields.push('Телефон');
          } else {
            phoneStep2_2.classList.remove('error');
          }
        } else if (!phoneStep2_2.value.trim()) {
          phoneStep2_2.classList.add('error');
          isValid = false;
          missingFields.push('Телефон');
        } else {
          phoneStep2_2.classList.remove('error');
        }
      }

      if (!email2.value || !validateEmail(email2.value)) {
        email2.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        email2.classList.remove('error');
      }

      // birthDate2 и childName2 - необязательные поля, не проверяем

      const parentName2 = document.getElementById('parent_name_2');
      const childName2 = document.getElementById('child_name_2');

      if (!parentName2.value) {
        parentName2.classList.add('error');
        isValid = false;
        missingFields.push('Имя и фамилия родителя');
      } else {
        parentName2.classList.remove('error');
      }

      // childName2 - необязательное поле, не проверяем

      if (!campus2.value) {
        campus2.classList.add('error');
        isValid = false;
        missingFields.push('Кампус');
      } else {
        campus2.classList.remove('error');
      }

      if (!isValid) {
        const message = 'Пожалуйста, заполните обязательные поля: ' + missingFields.join(', ');
        alert(message);
        return;
      }

      // Здесь можно добавить отправку данных на сервер
      const form = submitStep2_2.closest('form');
      if (!form) {
        return;
      }
      setFormSubmitting(form, true);
      submitLandingForm(e.currentTarget);
      // alert('Заявка успешно отправлена!');
    });
  }
};

// Инициализация валидации для третьей формы (step 2)
const initForm3 = () => {
  const email3 = document.getElementById('email_3');
  const birthDate3 = document.getElementById('birth_date_3');
  const campus3 = document.getElementById('campus_3');
  const campusImage3 = document.getElementById('campusImage_3');
  const campusCaption3 = document.getElementById('campusCaption_3');
  const campusImage3Desktop = document.getElementById('campusImage_3_desktop');
  const campusCaption3Desktop = document.getElementById('campusCaption_3_desktop');
  const submitStep2_3 = document.getElementById('submitStep2_3');

  if (email3) {
    email3.addEventListener('input', () => {
      if (email3.value && validateEmail(email3.value)) {
        email3.classList.remove('error');
      }
    });
    email3.addEventListener('blur', () => {
      if (email3.value && !validateEmail(email3.value)) {
        email3.classList.add('error');
      } else {
        email3.classList.remove('error');
      }
    });
  }

  if (birthDate3) {
    // Маска для даты рождения
    birthDate3.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      if (value.length >= 5) {
        value = value.slice(0, 5) + '.' + value.slice(5, 9);
      }
      e.target.value = value;
    });

    birthDate3.addEventListener('input', () => {
      if (birthDate3.value && validateBirthDate(birthDate3.value)) {
        birthDate3.classList.remove('error');
      }
    });
    birthDate3.addEventListener('blur', () => {
      if (birthDate3.value && !validateBirthDate(birthDate3.value)) {
        birthDate3.classList.add('error');
      } else {
        birthDate3.classList.remove('error');
      }
    });
  }

  if (campus3 && campusImage3) {
    updateCampusImage(campus3, campusImage3, campusCaption3, campusImage3Desktop, campusCaption3Desktop);
  }

  // Добавляем обработчики для удаления error при корректном вводе
  const phoneStep2_3 = document.getElementById('phone_step2_3');
  if (phoneStep2_3) {
    phoneStep2_3.addEventListener('input', () => {
      const phoneWrapper = phoneStep2_3.closest('.phone_wrapper');
      const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
      const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
      // Используем универсальную валидацию из countryCodes.js
      if (window.validatePhoneNumber && phoneStep2_3.value.trim()) {
        const validation = window.validatePhoneNumber(phoneStep2_3.value, code);
        if (validation.valid) {
          phoneStep2_3.classList.remove('error');
        }
      }
    });
  }

  const parentName3 = document.getElementById('parent_name_3');
  if (parentName3) {
    parentName3.addEventListener('input', () => {
      if (parentName3.value) {
        parentName3.classList.remove('error');
      }
    });
  }

  const childName3 = document.getElementById('child_name_3');
  if (childName3) {
    childName3.addEventListener('input', () => {
      if (childName3.value) {
        childName3.classList.remove('error');
      }
    });
  }

  if (campus3) {
    campus3.addEventListener('change', () => {
      if (campus3.value) {
        campus3.classList.remove('error');
      }
    });
  }

  if (submitStep2_3) {
    submitStep2_3.addEventListener('click', (e) => {
      e.preventDefault();

      // Валидация всех полей
      let isValid = true;
      const missingFields = [];

      // Валидация телефона
      const phoneStep2_3 = document.getElementById('phone_step2_3');
      if (phoneStep2_3) {
        const phoneWrapper = phoneStep2_3.closest('.phone_wrapper');
        const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
        const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
        const phoneCodeHidden = phoneWrapper ? phoneWrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
        if (phoneCodeHidden) phoneCodeHidden.value = code;

        // Используем универсальную валидацию из countryCodes.js
        if (window.validatePhoneNumber && phoneStep2_3.value.trim()) {
          const validation = window.validatePhoneNumber(phoneStep2_3.value, code);
          if (!validation.valid) {
            phoneStep2_3.classList.add('error');
            isValid = false;
            missingFields.push('Телефон');
          } else {
            phoneStep2_3.classList.remove('error');
          }
        } else if (!phoneStep2_3.value.trim()) {
          phoneStep2_3.classList.add('error');
          isValid = false;
          missingFields.push('Телефон');
        } else {
          phoneStep2_3.classList.remove('error');
        }
      }

      if (!email3.value || !validateEmail(email3.value)) {
        email3.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        email3.classList.remove('error');
      }

      // birthDate3 и childName3 - необязательные поля, не проверяем

      const parentName3 = document.getElementById('parent_name_3');
      const childName3 = document.getElementById('child_name_3');

      if (!parentName3.value) {
        parentName3.classList.add('error');
        isValid = false;
        missingFields.push('Имя и фамилия родителя');
      } else {
        parentName3.classList.remove('error');
      }

      // childName3 - необязательное поле, не проверяем

      if (!campus3.value) {
        campus3.classList.add('error');
        isValid = false;
        missingFields.push('Кампус');
      } else {
        campus3.classList.remove('error');
      }

      if (!isValid) {
        const message = 'Пожалуйста, заполните обязательные поля: ' + missingFields.join(', ');
        alert(message);
        return;
      }

      // Здесь можно добавить отправку данных на сервер
      const form = submitStep2_3.closest('form');
      if (!form) {
        return;
      }
      if (typeof setFormSubmitting === 'function') {
        setFormSubmitting(form, true);
      } else if (typeof window.setFormSubmitting === 'function') {
        window.setFormSubmitting(form, true);
      }
      submitLandingForm(e.currentTarget);
      // alert('Заявка успешно отправлена!');
    });
  }
};

// Инициализация валидации для четвертой формы (block18) - вторая страница
const initForm4 = () => {
  const email4 = document.getElementById('email_4');
  const birthDate4 = document.getElementById('birth_date_4');
  const submitStep2_4 = document.getElementById('submitStep2_4');

  if (email4) {
    email4.addEventListener('input', () => {
      if (email4.value && validateEmail(email4.value)) {
        email4.classList.remove('error');
      }
    });
    email4.addEventListener('blur', () => {
      if (email4.value && !validateEmail(email4.value)) {
        email4.classList.add('error');
      } else {
        email4.classList.remove('error');
      }
    });
  }

  if (birthDate4) {
    birthDate4.addEventListener('input', (e) => {
      let value = e.target.value.replace(/\D/g, '');
      if (value.length >= 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      if (value.length >= 5) {
        value = value.slice(0, 5) + '.' + value.slice(5, 9);
      }
      e.target.value = value;
    });

    birthDate4.addEventListener('input', () => {
      if (birthDate4.value && validateBirthDate(birthDate4.value)) {
        birthDate4.classList.remove('error');
      }
    });
    birthDate4.addEventListener('blur', () => {
      if (birthDate4.value && !validateBirthDate(birthDate4.value)) {
        birthDate4.classList.add('error');
      } else {
        birthDate4.classList.remove('error');
      }
    });
  }

  // Добавляем обработчики для удаления error при корректном вводе
  const phoneStep2_4 = document.getElementById('phone_step2_4');
  if (phoneStep2_4) {
    phoneStep2_4.addEventListener('input', () => {
      const phoneWrapper = phoneStep2_4.closest('.phone_wrapper');
      const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
      const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
      // Используем универсальную валидацию из countryCodes.js
      if (window.validatePhoneNumber && phoneStep2_4.value.trim()) {
        const validation = window.validatePhoneNumber(phoneStep2_4.value, code);
        if (validation.valid) {
          phoneStep2_4.classList.remove('error');
        }
      }
    });
  }

  const parentName4 = document.getElementById('parent_name_4');
  if (parentName4) {
    parentName4.addEventListener('input', () => {
      if (parentName4.value) {
        parentName4.classList.remove('error');
      }
    });
  }

  const childName4 = document.getElementById('child_name_4');
  if (childName4) {
    childName4.addEventListener('input', () => {
      if (childName4.value) {
        childName4.classList.remove('error');
      }
    });
  }

  const campus4 = document.getElementById('campus_4');
  const campusImage4 = document.getElementById('campusImage_4');
  const campusCaption4 = document.getElementById('campusCaption_4');
  const campusImage4Desktop = document.getElementById('campusImage_4_desktop');
  const campusCaption4Desktop = document.getElementById('campusCaption_4_desktop');

  if (campus4) {
    campus4.addEventListener('change', () => {
      if (campus4.value) {
        campus4.classList.remove('error');
      }
    });

    // Обновляем изображение кампуса для формы 4
    if (campusImage4) {
      updateCampusImage(campus4, campusImage4, campusCaption4, campusImage4Desktop, campusCaption4Desktop);
    }
  }

  if (submitStep2_4) {
    submitStep2_4.addEventListener('click', (e) => {
      e.preventDefault();

      let isValid = true;
      const missingFields = [];

      const phoneStep2_4 = document.getElementById('phone_step2_4');
      if (phoneStep2_4) {
        const phoneWrapper = phoneStep2_4.closest('.phone_wrapper');
        const phoneCodeEl = phoneWrapper ? phoneWrapper.querySelector('.phone-code') : null;
        const code = phoneCodeEl ? phoneCodeEl.textContent.trim() : '+7';
        const phoneCodeHidden = phoneWrapper ? phoneWrapper.querySelector('input[type="hidden"][name="request[parent_phone_code]"]') : null;
        if (phoneCodeHidden) phoneCodeHidden.value = code;

        // Используем универсальную валидацию из countryCodes.js
        if (window.validatePhoneNumber && phoneStep2_4.value.trim()) {
          const validation = window.validatePhoneNumber(phoneStep2_4.value, code);
          if (!validation.valid) {
            phoneStep2_4.classList.add('error');
            isValid = false;
            missingFields.push('Телефон');
          } else {
            phoneStep2_4.classList.remove('error');
          }
        } else if (!phoneStep2_4.value.trim()) {
          phoneStep2_4.classList.add('error');
          isValid = false;
          missingFields.push('Телефон');
        } else {
          phoneStep2_4.classList.remove('error');
        }
      }

      if (!email4.value || !validateEmail(email4.value)) {
        email4.classList.add('error');
        isValid = false;
        missingFields.push('Email');
      } else {
        email4.classList.remove('error');
      }

      // birthDate4 и childName4 - необязательные поля, не проверяем

      const parentName4 = document.getElementById('parent_name_4');
      const childName4 = document.getElementById('child_name_4');

      if (!parentName4.value) {
        parentName4.classList.add('error');
        isValid = false;
        missingFields.push('Имя и фамилия родителя');
      } else {
        parentName4.classList.remove('error');
      }

      if (!campus4.value) {
        campus4.classList.add('error');
        isValid = false;
        missingFields.push('Кампус');
      } else {
        campus4.classList.remove('error');
      }

      // childName4 - необязательное поле, не проверяем

      if (!isValid) {
        const message = 'Пожалуйста, заполните обязательные поля: ' + missingFields.join(', ');
        alert(message);
        return;
      }

      // Здесь можно добавить отправку формы
      const form = submitStep2_4.closest('form');
      if (!form) {
        return;
      }
      if (typeof setFormSubmitting === 'function') {
        setFormSubmitting(form, true);
      } else if (typeof window.setFormSubmitting === 'function') {
        window.setFormSubmitting(form, true);
      }
      submitLandingForm(e.currentTarget);
      // alert('Спасибо! Ваша заявка отправлена.');
    });
  }
};

// Инициализация всех форм после загрузки DOM
function initAllForms() {
  initForm1();
  initForm2();
  initForm3();
  initForm4();

  // Инициализация антибота для формы брошюры (block7) - как в формах 3 и 4
  const antibotLabelBlock7 = document.getElementById('antibotLabelBlock7');
  if (antibotLabelBlock7) {
    antibot7 = generateAntibot();
    updateAntibotLabel(antibotLabelBlock7, antibot7);
    antibotLabelBlock7.setAttribute('data-answer', antibot7.answer);
    window.antibot7 = antibot7;
  }
}

// Обновление CSRF-токена после ответа landing_create
const updateCsrfToken = (token) => {
  if (!token) return;
  const meta = document.querySelector("meta[name='csrf-token']");
  if (meta) meta.setAttribute('content', token);
  document.querySelectorAll("input[name='authenticity_token']").forEach((input) => {
    input.value = token;
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllForms);
} else {
  // DOM уже загружен
  initAllForms();
}

document.addEventListener('ajax:complete', (event) => {
  const target = event.target;
  if (!target || target.tagName !== 'FORM') return;
  const action = target.getAttribute('action') || '';
  if (!action.includes('landing-2025/requests')) return;

  const detail = event.detail || [];
  const xhr = detail[2];
  if (xhr && xhr.getResponseHeader) {
    const headerToken = xhr.getResponseHeader('X-CSRF-Token');
    if (headerToken) {
      updateCsrfToken(headerToken);
      return;
    }
  }

  const metaToken = document.querySelector("meta[name='csrf-token']")?.content;
  if (metaToken) updateCsrfToken(metaToken);
});

// ============================================
// ПОИСК ПО САЙТУ
// ============================================
const searchInput = document.getElementById('searchInput');
const searchButton = document.getElementById('searchButton');

// Функция для удаления предыдущих выделений
function removeHighlights() {
  const highlights = document.querySelectorAll('.search-highlight');
  highlights.forEach(highlight => {
    const parent = highlight.parentNode;
    parent.replaceChild(document.createTextNode(highlight.textContent), highlight);
    parent.normalize();
  });
}

// Функция для выделения найденного текста
function highlightText(element, searchText) {
  const walker = document.createTreeWalker(
    element,
    NodeFilter.SHOW_TEXT,
    null,
    false
  );

  const textNodes = [];
  let node;
  while (node = walker.nextNode()) {
    if (node.textContent.toLowerCase().includes(searchText.toLowerCase())) {
      textNodes.push(node);
    }
  }

  textNodes.forEach(textNode => {
    const text = textNode.textContent;
    const regex = new RegExp(`(${searchText})`, 'gi');
    const highlightedText = text.replace(regex, '<mark class="search-highlight">$1</mark>');

    if (highlightedText !== text) {
      const wrapper = document.createElement('span');
      wrapper.innerHTML = highlightedText;
      textNode.parentNode.replaceChild(wrapper, textNode);
    }
  });
}

// Функция поиска
function performSearch(searchText) {
  // Удаляем предыдущие выделения всегда
  removeHighlights();

  if (!searchText || searchText.trim() === '') {
    return;
  }

  // Исключаем элементы, которые не должны быть найдены
  const excludeSelectors = 'script, style, noscript, .search, header, nav';
  const allElements = document.querySelectorAll('body *');
  let found = false;
  let firstFoundElement = null;

  allElements.forEach(element => {
    // Пропускаем исключенные элементы и их дочерние элементы
    if (element.matches(excludeSelectors) || element.closest(excludeSelectors)) {
      return;
    }

    // Ищем текст в элементе
    const text = element.textContent || element.innerText || '';
    if (text.toLowerCase().includes(searchText.toLowerCase())) {
      // Проверяем, что это не дочерний элемент уже найденного
      if (!element.closest('.search-highlight')) {
        found = true;
        if (!firstFoundElement) {
          firstFoundElement = element;
        }

        // Выделяем текст в элементе
        highlightText(element, searchText);
      }
    }
  });

  // Прокручиваем к первому найденному элементу
  if (firstFoundElement) {
    firstFoundElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Добавляем временный класс для визуального выделения
    firstFoundElement.style.transition = 'background-color 0.3s';
    firstFoundElement.style.backgroundColor = '#fff3cd';
    setTimeout(() => {
      firstFoundElement.style.backgroundColor = '';
    }, 2000);
  } else {
    alert('Ничего не найдено. Попробуйте другой запрос.');
  }
}

// Обработчики событий
if (searchInput && searchButton) {
  // Поиск по нажатию кнопки
  searchButton.addEventListener('click', (e) => {
    // На мобильных экранах (≤1195px) мобильный обработчик перехватит событие через stopPropagation
    // Здесь обрабатываем только большие экраны
    if (window.innerWidth <= 1195) {
      return; // Мобильный обработчик обработает это событие
    }
    e.preventDefault();
    const searchText = searchInput.value.trim();
    // Всегда вызываем performSearch, даже если запрос пустой (для удаления предыдущих выделений)
    performSearch(searchText);
  });

  // Поиск по нажатию Enter
  searchInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const searchText = searchInput.value.trim();
      // Всегда вызываем performSearch, даже если запрос пустой (для удаления предыдущих выделений)
      performSearch(searchText);
    }
  });
}

// ============================================
// ПЕРЕВОД СТРАНИЦЫ НА АНГЛИЙСКИЙ
// ============================================
// ПЕРЕВОДЫ ВЫНЕСЕНЫ В ОТДЕЛЬНЫЕ ФАЙЛЫ
// См. src/js/translation/
// ============================================
// currentLang объявлен в languageSwitcher.js


// Код слайдеров отзывов, новостей и преподавателей вынесен в components/reviewsSlider.js, newsSlider.js, teachersSlider.js

// ============================================
// МОБИЛЬНОЕ МЕНЮ
// ============================================
function initMobileMenu() {
  if (document.body.classList.contains('middle-high-page')) return;
  /* Начальная школа: меню и скролл шапки в public/primary/js/script.js — иначе два toggle на .mobile-menu-btn схлопывают меню */
  if (document.body.classList.contains('primary-school-page')) return;
  const mobileMenuBtn = document.querySelector('.mobile-menu-btn');
  const navBar = document.querySelector('.nav-bar');
  const dropdownItems = document.querySelectorAll('.nav-bar > ul > li.dropdown');

  // Обработчик клика на кнопку мобильного меню (в nav-bar)
  if (mobileMenuBtn && navBar) {
    mobileMenuBtn.addEventListener(
      'click',
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        navBar.classList.toggle('mobile-menu-open');
        if (window.innerWidth <= 1195) {
          setTimeout(() => {
            if (typeof updateCharterVisibility === 'function') {
              updateCharterVisibility();
            }
          }, 0);
        }
      },
      true
    );

    // Закрываем меню при клике вне его
    document.addEventListener('click', (e) => {
      if (!navBar.contains(e.target) && !mobileMenuBtn.contains(e.target)) {
        navBar.classList.remove('mobile-menu-open');
      }
    });
  }

  // Обработчик клика на кнопку меню в header (icons-menu-btn)
  const iconsMenuBtn = document.getElementById('iconsMenuBtn');
  if (iconsMenuBtn && navBar) {
    iconsMenuBtn.addEventListener(
      'click',
      (e) => {
      e.stopPropagation();
      e.preventDefault(); // Предотвращаем стандартное поведение

      // Для 1196px+ просто раскрываем nav-bar (убираем nav-bar-scrolled)
      if (window.innerWidth >= 1196) {
        navBar.classList.remove('nav-bar-scrolled');
        // Скрываем кнопку меню и убираем классы has-menu-btn
        iconsMenuBtn.classList.remove('visible');
        const iconsContainer = iconsMenuBtn.closest('.icons');
        if (iconsContainer) iconsContainer.classList.remove('has-menu-btn');
        const contactsContainer = iconsContainer ? iconsContainer.closest('.contacts') : null;
        if (contactsContainer) contactsContainer.classList.remove('has-menu-btn');
        const topBar = document.querySelector('.top_bar');
        if (topBar) topBar.classList.remove('has-menu-btn');
        // Обновляем позицию после раскрытия
        if (typeof updateNavBarPosition === 'function') {
          updateNavBarPosition();
        }
      } else if (window.innerWidth >= 769 && window.innerWidth <= 1195) {
        // Для 769px-1195px: убираем nav-bar-scrolled (чтобы nav-bar появился), открываем mobile-menu-open (чтобы ul раскрылся), скрываем кнопку меню
        navBar.classList.remove('nav-bar-scrolled');
        navBar.classList.add('mobile-menu-open');
        // Скрываем кнопку меню и убираем классы has-menu-btn
        iconsMenuBtn.classList.remove('visible');
        const iconsContainer = iconsMenuBtn.closest('.icons');
        if (iconsContainer) iconsContainer.classList.remove('has-menu-btn');
        const contactsContainer = iconsContainer ? iconsContainer.closest('.contacts') : null;
        if (contactsContainer) contactsContainer.classList.remove('has-menu-btn');
        const topBar = document.querySelector('.top_bar');
        if (topBar) topBar.classList.remove('has-menu-btn');
        // Обновляем позицию после раскрытия
        if (typeof updateNavBarPosition === 'function') {
          updateNavBarPosition();
        }
        // Обновляем видимость "Устав"
        setTimeout(() => {
          if (typeof updateCharterVisibility === 'function') {
            updateCharterVisibility();
          }
        }, 0);
      } else {
        // Для других размеров экрана (768px и меньше): убираем nav-bar-scrolled (чтобы nav-bar появился), открываем mobile-menu-open (чтобы ul раскрылся)
        navBar.classList.remove('nav-bar-scrolled');
        navBar.classList.add('mobile-menu-open');
        // Скрываем кнопку меню при открытии меню на мобильных
        iconsMenuBtn.classList.add('hidden');
        // Убираем классы has-menu-btn
        const iconsContainer = iconsMenuBtn.closest('.icons');
        if (iconsContainer) iconsContainer.classList.remove('has-menu-btn');
        const contactsContainer = iconsContainer ? iconsContainer.closest('.contacts') : null;
        if (contactsContainer) contactsContainer.classList.remove('has-menu-btn');
        const topBar = document.querySelector('.top_bar');
        if (topBar) topBar.classList.remove('has-menu-btn');
        // Обновляем позицию после раскрытия
        if (typeof updateNavBarPosition === 'function') {
          updateNavBarPosition();
        }
        // Обновляем видимость "Устав"
        setTimeout(() => {
          if (typeof updateCharterVisibility === 'function') {
            updateCharterVisibility();
          }
        }, 0);
      }
    },
      true
    );
  }

  // Функция для обновления видимости пункта "Устав"
  function updateCharterVisibility() {
    if (window.innerWidth <= 1195) {
      let currentRegion = 'Россия';
      try {
        if (typeof window.getCookie === 'function' && typeof window.COOKIE_NAME !== 'undefined') {
          const raw = window.getCookie(window.COOKIE_NAME);
          if (raw) {
            const parsed = JSON.parse(raw);
            if (parsed && typeof parsed === 'object' && parsed.name) {
              currentRegion = parsed.name;
            }
          }
        }
      } catch (e) {
        currentRegion = 'Россия';
      }
      const isUzbekistan = currentRegion === 'Узбекистан' || currentRegion === 'Uzbekistan';
      const charterNavLinks = document.querySelectorAll('.js-charter-nav');
      charterNavLinks.forEach(link => {
        link.style.setProperty('display', isUzbekistan ? '' : 'none', 'important');
      });
    }
  }

  // Обработчики для dropdown элементов в мобильном меню
  if (dropdownItems.length > 0) {
    dropdownItems.forEach(item => {
      // Ищем прямой дочерний элемент <a> или первый <a> внутри элемента
      const dropdownLink = item.querySelector(':scope > a') || item.querySelector('a');
      if (dropdownLink) {
        dropdownLink.addEventListener('click', (e) => {
          // На мобильных устройствах и планшетах (до 1195px) переключаем dropdown
          if (window.innerWidth <= 1195) {
            e.preventDefault();
            e.stopPropagation();
            const isCurrentlyOpen = item.classList.contains('dropdown-open');

            // Закрываем все остальные dropdown
            dropdownItems.forEach(otherItem => {
              if (otherItem !== item) {
                otherItem.classList.remove('dropdown-open');
              }
            });

            // Переключаем текущий dropdown (если был открыт - закроется, если закрыт - откроется)
            if (isCurrentlyOpen) {
              item.classList.remove('dropdown-open');
            } else {
              item.classList.add('dropdown-open');
            }

            // Обновляем видимость пункта "Устав" при открытии dropdown "Мир CIS" (первый dropdown, индекс 0)
            const dropdownIndex = Array.from(dropdownItems).indexOf(item);
            if (dropdownIndex === 0) {
              setTimeout(() => {
                updateCharterVisibility();
              }, 0);
            }
          }
        });
      }

      // Обработчик для ссылок внутри dropdown-menu на мобильных устройствах
      const dropdownMenu = item.querySelector('.dropdown-menu');
      if (dropdownMenu) {
        // Используем делегирование событий для ссылок внутри dropdown-menu
        dropdownMenu.addEventListener('click', (e) => {
          // На мобильных устройствах останавливаем всплытие для ссылок внутри dropdown-menu
          const link = e.target.closest('a');
          if (window.innerWidth <= 1195 && link && dropdownMenu.contains(link)) {
            e.stopPropagation();
            e.stopImmediatePropagation();
          }
        }, { capture: true });
      }
    });
  }

  // Обновляем видимость "Устав" при открытии мобильного меню
  if (navBar) {
    const observer = new MutationObserver(() => {
      if (navBar.classList.contains('mobile-menu-open')) {
        setTimeout(() => {
          updateCharterVisibility();
        }, 0);
      }
    });
    observer.observe(navBar, { attributes: true, attributeFilter: ['class'] });

    // Обновляем видимость при загрузке, если меню уже открыто
    if (navBar.classList.contains('mobile-menu-open')) {
      setTimeout(() => {
        updateCharterVisibility();
      }, 100);
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initMobileMenu);
} else {
  initMobileMenu();
}

// ============================================
// УПРАВЛЕНИЕ ВИДИМОСТЬЮ NAV-BAR ПРИ СКРОЛЛЕ
// ============================================
(function () {
  if (document.body.classList.contains('middle-high-page')) return;
  if (document.body.classList.contains('primary-school-page')) return;

  function getScrollTop() {
    const page = document.getElementById('page');
    if (page) {
      const oy = window.getComputedStyle(page).overflowY;
      const pageCanScroll =
        (oy === 'auto' || oy === 'scroll' || oy === 'overlay') &&
        page.scrollHeight > page.clientHeight + 1;
      if (pageCanScroll) {
        const py = page.scrollTop ?? 0;
        return py < 0 ? 0 : py;
      }
    }
    const y =
      window.pageYOffset ??
      document.documentElement?.scrollTop ??
      document.scrollingElement?.scrollTop ??
      document.body?.scrollTop ??
      0;
    return y < 0 ? 0 : y;
  }

  function initNavBarScroll() {
    let lastScrollTop = 0;
    const navBar = document.querySelector('.nav-bar');
    const iconsMenuBtn = document.getElementById('iconsMenuBtn');
    const topBar = document.querySelector('.top_bar');

    if (!navBar) return;

    function updateNavBarPosition() {
      if (topBar && navBar) {
        const topBarRect = topBar.getBoundingClientRect();
        const topBarBottom = topBarRect.bottom;
        const windowWidth = window.innerWidth;
        const finalHeight = topBarBottom > 0 ? topBarBottom : (windowWidth >= 1196 ? 90 : 74);
        document.documentElement.style.setProperty('--top-bar-height', finalHeight + 'px');
      }
    }
    window.updateNavBarPosition = updateNavBarPosition;

    requestAnimationFrame(() => {
    updateNavBarPosition();
  });

  window.addEventListener('resize', () => {
    requestAnimationFrame(() => {
      setTimeout(updateNavBarPosition, 50);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      requestAnimationFrame(() => {
        setTimeout(updateNavBarPosition, 100);
        setTimeout(updateNavBarPosition, 300);
      });
    });
  } else {
    requestAnimationFrame(() => {
      setTimeout(updateNavBarPosition, 100);
      setTimeout(updateNavBarPosition, 300);
      setTimeout(updateNavBarPosition, 500);
    });
  }

  window.addEventListener('load', () => {
    requestAnimationFrame(() => {
      setTimeout(updateNavBarPosition, 100);
    });
  });

  const observer = new MutationObserver(() => {
    requestAnimationFrame(() => {
      updateNavBarPosition();
    });
  });

  if (topBar) {
    observer.observe(topBar, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
      subtree: true
    });
  }

    function updateNavBarVisibility() {
      const scrollTop = getScrollTop();
      const iconsContainer = iconsMenuBtn ? iconsMenuBtn.closest('.icons') : null;
      const contactsContainer = iconsContainer ? iconsContainer.closest('.contacts') : null;
      const topBarEl = document.querySelector('.top_bar');

      updateNavBarPosition();

      if (scrollTop > lastScrollTop && scrollTop > 10) {
        navBar.classList.add('nav-bar-scrolled');
        navBar.classList.remove('mobile-menu-open');
        if (iconsMenuBtn) {
          iconsMenuBtn.classList.remove('hidden');
          iconsMenuBtn.classList.add('visible');
        }
        if (iconsContainer) iconsContainer.classList.add('has-menu-btn');
        if (contactsContainer) contactsContainer.classList.add('has-menu-btn');
        if (topBarEl) topBarEl.classList.add('has-menu-btn');
        updateNavBarPosition();
      } else if (scrollTop < lastScrollTop) {
        navBar.classList.remove('nav-bar-scrolled');
        navBar.classList.remove('mobile-menu-open');
        if (iconsMenuBtn) {
          iconsMenuBtn.classList.add('hidden');
          iconsMenuBtn.classList.remove('visible');
        }
        if (iconsContainer) iconsContainer.classList.remove('has-menu-btn');
        if (contactsContainer) contactsContainer.classList.remove('has-menu-btn');
        if (topBarEl) topBarEl.classList.remove('has-menu-btn');
        updateNavBarPosition();
      }

      if (scrollTop <= 10) {
        navBar.classList.remove('nav-bar-scrolled');
        navBar.classList.remove('mobile-menu-open');
        if (iconsMenuBtn) {
          iconsMenuBtn.classList.add('hidden');
          iconsMenuBtn.classList.remove('visible');
        }
        if (iconsContainer) iconsContainer.classList.remove('has-menu-btn');
        if (contactsContainer) contactsContainer.classList.remove('has-menu-btn');
        if (topBarEl) topBarEl.classList.remove('has-menu-btn');
        updateNavBarPosition();
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    let ticking = false;
    function onScrollOrResize() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          updateNavBarVisibility();
          ticking = false;
        });
        ticking = true;
      }
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    const pageScrollEl = document.getElementById('page');
    if (pageScrollEl) {
      pageScrollEl.addEventListener('scroll', onScrollOrResize, { passive: true });
    }

    window.addEventListener('resize', () => {
      updateNavBarVisibility();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        updateNavBarVisibility();
      });
    } else {
      updateNavBarVisibility();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavBarScroll);
  } else {
    initNavBarScroll();
  }
})();

(function () {
  let previousWidth = window.innerWidth;
  let reloadTimeout = null;

  window.addEventListener('resize', () => {
    clearTimeout(reloadTimeout);
    reloadTimeout = setTimeout(() => {
      const currentWidth = window.innerWidth;

      if (previousWidth <= 768 && currentWidth >= 769) {
        window.location.reload();
      }
      else if (previousWidth >= 769 && currentWidth <= 768) {
        window.location.reload();
      }

      previousWidth = currentWidth;
    }, 150);
  });
})();

// Функция для оборачивания цены в accordion_column_left, чтобы предотвратить разрыв при переносе строки
function wrapAccordionPrices() {
  const accordionColumnLefts = document.querySelectorAll('.accordion_column_left');

  accordionColumnLefts.forEach(column => {
    const paragraphs = column.querySelectorAll('p');

    paragraphs.forEach(p => {
      const text = p.textContent;
      // Ищем паттерн цены: число с пробелами + валюта (₽, €, Р, UZS, сумов и т.д.)
      const pricePattern = /(\d{1,3}(?:\s\d{3})*(?:\s\d{3})*)\s*([₽€Р]|UZS|сумов)/g;

      if (pricePattern.test(text)) {
        // Проверяем, не обернута ли уже цена
        if (!p.querySelector('.accordion_price')) {
          // Заменяем текст, оборачивая цену в span
          p.innerHTML = p.innerHTML.replace(pricePattern, '<span class="accordion_price">$1 $2</span>');
        }
      }
    });
  });
}

// Вызываем функцию при загрузке DOM и после изменения языка/региона
function initWrapAccordionPricesOnLoad() {
  wrapAccordionPrices();

  // Также вызываем после небольшой задержки, чтобы убедиться, что все элементы загружены
  setTimeout(wrapAccordionPrices, 100);
  setTimeout(wrapAccordionPrices, 500);
}

if (document.readyState === "loading") {
  document.addEventListener('DOMContentLoaded', initWrapAccordionPricesOnLoad);
} else {
  initWrapAccordionPricesOnLoad();
}

// Вызываем после изменения языка (если используется translatePage)
if (typeof translatePage === 'function') {
  const originalTranslatePage = translatePage;
  window.translatePage = function (...args) {
    const result = originalTranslatePage.apply(this, args);
    setTimeout(wrapAccordionPrices, 100);
    return result;
  };
}

// Инициализация формы подписки на рассылку (block20)
const initNewsletterForm = () => {
  const newsletterForm = document.getElementById('block20NewsletterForm');
  if (!newsletterForm) return;

  const email20 = document.getElementById('email20');
  const comment20 = document.getElementById('comment20');
  const submitBtn20 = document.getElementById('submitBtn20');
  const antibotLabel20 = document.getElementById('antibotLabel20');

  // Генерируем антибот для формы подписки (как в других формах)
  let antibot20 = generateAntibot();
  if (antibotLabel20) {
    updateAntibotLabel(antibotLabel20, antibot20);
  }

  // Функция обновления состояния кнопки
  const updateNewsletterButton = () => {
    if (!submitBtn20 || !email20 || !comment20) return;

    const emailValid = email20.value.trim() !== '' && validateEmail(email20.value.trim());
    const antibotValid = checkAntibot(comment20.value, antibot20.answer);

    submitBtn20.disabled = !(emailValid && antibotValid);
  };

  // Валидация email
  if (email20) {
    email20.addEventListener('input', () => {
      if (email20.value && validateEmail(email20.value)) {
        email20.classList.remove('error');
      }
      updateNewsletterButton();
    });

    email20.addEventListener('blur', () => {
      if (email20.value && !validateEmail(email20.value)) {
        email20.classList.add('error');
      } else {
        email20.classList.remove('error');
      }
      updateNewsletterButton();
    });
  }

  // Валидация антибота
  if (comment20) {
    comment20.addEventListener('input', () => {
      updateNewsletterButton();
    });

    comment20.addEventListener('blur', () => {
      updateNewsletterButton();
    });
  }

  // Инициализация кнопки при загрузке
  if (email20 && comment20 && submitBtn20) {
    setTimeout(() => {
      updateNewsletterButton();
    }, 500);
  }

  // Обработчик отправки формы
  newsletterForm.addEventListener('submit', (e) => {
    e.preventDefault();

    // Валидация перед отправкой
    if (!email20 || !validateEmail(email20.value.trim())) {
      alert('Пожалуйста, введите корректный email');
      email20.classList.add('error');
      return;
    }

    if (!checkAntibot(comment20.value, antibot20.answer)) {
      alert('Неверный ответ на вопрос антибота');
      // Генерируем новый антибот
      antibot20 = generateAntibot();
      if (antibotLabel20) {
        updateAntibotLabel(antibotLabel20, antibot20);
      }
      comment20.value = '';
      updateNewsletterButton();
      return;
    }

    window.callTouchHandlers?.handleForm(e.target); // CallTouch (see layouts/_calltouch.html)

    // Отключаем кнопку и показываем лоадер
    const submitButton = newsletterForm.querySelector('.block20_submit');
    const loader = newsletterForm.querySelector('.block20_loader');
    if (submitButton) submitButton.disabled = true;
    if (loader) loader.style.display = 'block';

    // Отправляем форму
    const formData = new FormData(newsletterForm);
    window.utmHandlers?.fillFormUtm(formData, 'request'); // append UTM (see javascripts/utils/utm-tags-handlers.js)

    const url = newsletterForm.action || newsletterForm.getAttribute('action');
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content ||
      newsletterForm.querySelector('input[name="authenticity_token"]')?.value;

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/javascript'
      },
      credentials: 'same-origin'
    })
      .then(response => {
        if (response.ok) {
          return response.text();
        } else {
          return response.text().then(text => {
            throw new Error('Ошибка отправки формы: ' + response.status);
          });
        }
      })
      .then(text => {
        // Выполняем JavaScript ответ от сервера
        const script = document.createElement('script');
        script.textContent = text;
        document.head.appendChild(script);
        document.head.removeChild(script);

        // Генерируем новый антибот после успешной отправки
        antibot20 = generateAntibot();
        if (antibotLabel20) {
          updateAntibotLabel(antibotLabel20, antibot20);
        }
        if (comment20) {
          comment20.value = '';
        }
      })
      .catch(error => {
        alert('Ошибка отправки формы: ' + error.message);
        if (submitButton) submitButton.disabled = false;
        if (loader) loader.style.display = 'none';
      });
  });
};

// Инициализация формы подписки после загрузки DOM
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initNewsletterForm();
  });
} else {
  initNewsletterForm();
}
